// package.json
var version = "2.2.0";

// src/ui/notifications/Notifications.tsx
import clsx28 from "clsx";
import { memo as memo3, useMemo as useMemo9 } from "react";

// src/ui/core/Header.tsx
import clsx9 from "clsx";

// src/ui/core/icons/ArrowLeftIcon.tsx
import { jsx } from "react/jsx-runtime";
var ArrowLeftIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M.661 8.615l6.187 5.906c.352.317.88.317 1.196-.035.316-.351.316-.879-.035-1.195L3.333 8.826h11.444c.492 0 .843-.351.843-.844a.833.833 0 00-.843-.843H3.333l4.676-4.43a.839.839 0 00.035-1.195.839.839 0 00-1.196-.035L.661 7.385C.485 7.56.38 7.77.38 7.982a.88.88 0 00.281.633z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/core/icons/ArrowRightIcon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ArrowRightIcon = (props) => /* @__PURE__ */ jsx2(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx2(
      "path",
      {
        d: "M15.339 8.615l-6.187 5.906c-.352.317-.88.317-1.196-.035-.316-.351-.316-.879.035-1.195l4.676-4.465H1.223c-.492 0-.843-.351-.843-.844 0-.457.351-.843.843-.843h11.444l-4.676-4.43a.839.839 0 01-.035-1.195.839.839 0 011.196-.035l6.187 5.906c.176.176.281.386.281.597a.88.88 0 01-.281.633z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/core/icons/BellButtonIcon.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var BellButtonIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx3("g", { fill: "currentColor", clipPath: "url(#a)", children: /* @__PURE__ */ jsx3("path", { d: "M10.14 1.925a1.3 1.3 0 1 0-2.279.006c-2.532.504-4.436 2.766-4.436 5.445v.664c0 1.642-.629 3.25-1.712 4.473l-.245.28c-.314.35-.384.803-.21 1.223.175.384.595.629 1.05.629h13.42c.419 0 .838-.245 1.013-.63.175-.419.105-.873-.21-1.222l-.244-.28a6.768 6.768 0 0 1-1.678-4.473v-.664c0-2.69-1.92-4.96-4.468-5.451ZM9.017 18c.594 0 1.154-.21 1.573-.63.42-.419.664-1.013.664-1.607H6.781c0 .594.21 1.188.629 1.608.419.42 1.013.629 1.607.629Z" }) }),
      /* @__PURE__ */ jsx3("defs", { children: /* @__PURE__ */ jsx3("clipPath", { id: "a", children: /* @__PURE__ */ jsx3("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }) })
    ]
  }
);

// src/ui/core/icons/BellButtonIconOutline.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var BellButtonIconOutline = (props) => /* @__PURE__ */ jsxs2(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx4(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.14 2.408a1.44 1.44 0 1 0-2.133 0h-.014c-2.463.405-4.32 2.53-4.32 5.062v1.148c0 1.518-.54 3.003-1.485 4.218l-.506.608a.838.838 0 0 0-.101.877c.135.27.405.439.743.439h13.5a.787.787 0 0 0 .708-.439.838.838 0 0 0-.101-.877l-.506-.608a6.871 6.871 0 0 1-1.452-4.218V7.47c0-2.531-1.89-4.657-4.32-5.062h-.013ZM8.803 3.96h.54a3.529 3.529 0 0 1 3.51 3.51v1.148c0 1.62.44 3.172 1.317 4.522H3.943a8.26 8.26 0 0 0 1.35-4.522V7.47a3.507 3.507 0 0 1 3.51-3.51Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx4(
        "path",
        {
          fill: "currentColor",
          d: "M10.592 17.392c.405-.404.641-.978.641-1.552h-4.32c0 .574.203 1.148.608 1.552.405.405.979.608 1.552.608.574 0 1.114-.203 1.52-.608Z"
        }
      )
    ]
  }
);

// src/ui/core/icons/BellIcon.tsx
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var BellIcon = (props) => /* @__PURE__ */ jsxs3(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx5("g", { fill: "currentColor", clipPath: "url(#a)", children: /* @__PURE__ */ jsx5("path", { d: "M6.76 1.283a.867.867 0 1 0-1.519.004 3.702 3.702 0 0 0-2.957 3.63v.443c0 1.095-.42 2.167-1.142 2.982l-.163.186a.754.754 0 0 0-.14.816c.117.256.396.42.7.42h8.946c.28 0 .56-.164.676-.42a.754.754 0 0 0-.14-.816l-.163-.186A4.512 4.512 0 0 1 9.74 5.36v-.443a3.702 3.702 0 0 0-2.98-3.634ZM6.012 12c.396 0 .769-.14 1.048-.42.28-.279.443-.675.443-1.071H4.52c0 .396.14.792.42 1.072.28.28.676.419 1.072.419Z" }) }),
      /* @__PURE__ */ jsx5("defs", { children: /* @__PURE__ */ jsx5("clipPath", { id: "a", children: /* @__PURE__ */ jsx5("path", { fill: "#fff", d: "M0 0h12v12H0z" }) }) })
    ]
  }
);

// src/ui/core/icons/CheckIcon.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var CheckIcon = (props) => /* @__PURE__ */ jsx6(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx6(
      "path",
      {
        d: "M14.8479 3.5092C15.2629 3.8923 15.2629 4.56273 14.8479 4.94583L6.6751 13.1186C6.292 13.5336 5.62158 13.5336 5.23848 13.1186L1.15209 9.03221C0.737064 8.64912 0.737064 7.97869 1.15209 7.59559C1.53519 7.18057 2.20561 7.18057 2.58871 7.59559L5.97275 10.9477L13.4113 3.5092C13.7944 3.09418 14.4648 3.09418 14.8479 3.5092Z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/core/icons/CloseIcon.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var CloseIcon = (props) => /* @__PURE__ */ jsx7(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx7(
      "path",
      {
        d: "M13.646 3.9L9.524 8.02l4.088 4.088a.752.752 0 010 1.133.752.752 0 01-1.134 0L8.356 9.155 4.27 13.242a.752.752 0 01-1.133 0c-.344-.309-.344-.824 0-1.167l4.087-4.088L3.136 3.9c-.344-.31-.344-.825 0-1.168.309-.31.824-.31 1.167 0l4.088 4.122 4.087-4.088c.31-.343.825-.343 1.168 0 .31.31.31.825 0 1.134z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/core/icons/DialectLogo.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var DialectLogo = (props) => {
  return /* @__PURE__ */ jsx8(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: 45,
      height: 14,
      viewBox: "0 0 45 14",
      fill: "none",
      ...props,
      children: /* @__PURE__ */ jsx8(
        "path",
        {
          d: "M4.722 12.25H.958V2.068h3.759c1.037 0 1.93.204 2.68.612a4.18 4.18 0 011.74 1.75c.407.759.61 1.667.61 2.724 0 1.06-.203 1.972-.61 2.734A4.179 4.179 0 017.4 11.643c-.752.405-1.645.607-2.68.607zm-1.303-2.098h1.208c.57 0 1.052-.096 1.447-.288.398-.196.698-.513.9-.95.205-.44.308-1.028.308-1.76s-.103-1.316-.308-1.75c-.206-.438-.509-.752-.91-.945-.398-.195-.888-.293-1.472-.293H3.42v5.986zM10.485 12.25V4.614h2.43v7.636h-2.43zm1.218-8.526c-.342 0-.635-.113-.88-.338a1.088 1.088 0 01-.368-.826c0-.318.123-.59.368-.815.245-.229.538-.343.88-.343.344 0 .638.114.88.343.245.225.368.497.368.815 0 .322-.123.597-.368.826a1.244 1.244 0 01-.88.338zM15.916 12.38a3.26 3.26 0 01-1.298-.245 2.022 2.022 0 01-.89-.745c-.215-.335-.323-.754-.323-1.258 0-.424.075-.782.224-1.074a1.91 1.91 0 01.617-.71 2.9 2.9 0 01.904-.413c.342-.097.706-.161 1.094-.194.434-.04.784-.082 1.049-.125.265-.046.457-.11.577-.194a.418.418 0 00.184-.362v-.025c0-.256-.088-.453-.264-.592-.175-.14-.412-.209-.71-.209-.322 0-.58.07-.776.21a.92.92 0 00-.373.576l-2.242-.08c.066-.464.237-.878.512-1.243.278-.368.66-.656 1.143-.865.487-.212 1.072-.318 1.755-.318.487 0 .936.058 1.347.174.411.113.77.278 1.074.497.305.216.54.48.706.796.17.315.254.674.254 1.079v5.19h-2.287v-1.064h-.06c-.136.258-.31.477-.522.656a2.08 2.08 0 01-.74.403c-.282.09-.6.134-.955.134zm.75-1.592c.262 0 .498-.053.707-.159.212-.106.38-.252.507-.437.126-.19.189-.408.189-.657V8.81c-.07.036-.154.07-.254.099a5.709 5.709 0 01-.676.154l-.353.055a2.197 2.197 0 00-.587.169.926.926 0 00-.368.298.73.73 0 00-.124.428c0 .252.09.444.269.576.182.133.412.2.69.2zM23.697 2.068V12.25h-2.43V2.068h2.43zM28.114 12.394c-.798 0-1.488-.157-2.068-.472a3.266 3.266 0 01-1.332-1.357c-.308-.59-.462-1.291-.462-2.103 0-.79.155-1.479.467-2.069a3.374 3.374 0 011.317-1.382c.567-.331 1.235-.497 2.004-.497.543 0 1.04.085 1.491.254.451.169.84.419 1.169.75.328.332.583.741.765 1.228.183.484.274 1.04.274 1.666v.606h-6.637V7.606h4.375a1.37 1.37 0 00-.184-.69 1.25 1.25 0 00-.492-.473 1.421 1.421 0 00-.711-.174 1.45 1.45 0 00-.731.184 1.384 1.384 0 00-.711 1.193v1.437c0 .312.061.585.184.82.122.232.296.413.522.542.225.13.494.194.805.194.216 0 .411-.03.587-.09s.326-.147.452-.263c.126-.116.22-.258.284-.427l2.232.064c-.093.5-.297.937-.612 1.308-.311.368-.72.654-1.228.86-.507.202-1.093.303-1.76.303zM35.845 12.394c-.805 0-1.496-.166-2.073-.497a3.364 3.364 0 01-1.323-1.382c-.308-.594-.462-1.28-.462-2.058 0-.783.154-1.469.462-2.059a3.388 3.388 0 011.328-1.387c.576-.331 1.264-.497 2.063-.497.706 0 1.32.128 1.844.383.528.255.939.616 1.233 1.084.299.464.456 1.009.473 1.635h-2.272c-.047-.39-.18-.697-.398-.92-.215-.221-.497-.332-.845-.332a1.2 1.2 0 00-.74.238c-.213.156-.379.388-.498.696-.116.305-.174.683-.174 1.134 0 .45.058.832.174 1.143.12.308.285.542.497.701.212.156.46.234.74.234.226 0 .425-.048.597-.144.176-.096.32-.237.433-.423.113-.189.184-.418.214-.686h2.272c-.023.63-.18 1.18-.473 1.65-.288.471-.694.837-1.218 1.1-.52.258-1.138.387-1.854.387zM44.244 4.614v1.79h-4.817v-1.79h4.817zm-3.808-1.83h2.431v7.065c0 .149.023.27.07.362.05.09.12.155.214.194a.91.91 0 00.333.055c.092 0 .19-.008.293-.025.106-.02.186-.036.239-.05l.367 1.755c-.116.034-.28.075-.492.125-.209.05-.459.081-.75.094-.57.027-1.06-.04-1.467-.199a1.901 1.901 0 01-.93-.755c-.212-.342-.315-.77-.308-1.288V2.784z",
          fill: "currentColor"
        }
      )
    }
  );
};

// src/ui/core/icons/ResendIcon.tsx
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
var ResendIcon = (props) => /* @__PURE__ */ jsxs4(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx9(
        "path",
        {
          d: "M7.94 13.808v.034l.001-.034zM2.248 7.983h-.035.035zM8.072 2.29v-.034.034z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx9(
        "path",
        {
          d: "M12.502 11.678a.862.862 0 01-.253.613 5.984 5.984 0 01-4.242 1.759l-.043-.002-.036-.002a5.973 5.973 0 01-4.164-1.754 5.983 5.983 0 01-1.757-4.215.21.21 0 01-.001-.028l.001-.043c0-.013.002-.025.003-.035a5.972 5.972 0 011.754-4.164A5.982 5.982 0 017.977 2.05a.21.21 0 01.028-.002.933.933 0 01.078.004 6.018 6.018 0 011.953.351c.543.195 1.064.47 1.544.828l.668-1.156a.205.205 0 01.37.027l1.318 3.452a.205.205 0 01-.153.29l-3.65.582a.204.204 0 01-.223-.302l.797-1.38a4.245 4.245 0 00-2.664-.964l-.02.001a.217.217 0 01-.044 0 4.255 4.255 0 00-2.99 1.25 4.267 4.267 0 00-1.252 2.98v.02a.204.204 0 010 .045 4.256 4.256 0 001.25 2.99 4.267 4.267 0 002.96 1.253l.02-.002h.02a.22.22 0 01.045 0 4.255 4.255 0 002.981-1.24l.002-.002.004-.003v-.002l.003-.002a.863.863 0 011.213-.013l.005.004.003.003h.001l.003.004a.863.863 0 01.255.613z",
          fill: "currentColor"
        }
      )
    ]
  }
);

// src/ui/core/icons/SettingsIcon.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var SettingsIcon = (props) => /* @__PURE__ */ jsx10(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx10(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.829 2.543c.247.085.488.187.722.305.164.085.36.085.524 0l.713-.363a.578.578 0 01.677.106l.943.944c.18.177.223.452.107.677l-.363.713a.563.563 0 000 .523c.117.234.22.476.305.723a.567.567 0 00.372.37l.764.245c.242.076.405.3.403.554v1.335a.576.576 0 01-.41.547l-.764.245a.567.567 0 00-.368.365 5.772 5.772 0 01-.306.723.572.572 0 000 .525l.363.712a.578.578 0 01-.106.676l-.943.944a.579.579 0 01-.678.107l-.713-.363a.563.563 0 00-.523 0c-.234.117-.475.22-.722.305a.567.567 0 00-.37.372l-.246.764a.575.575 0 01-.554.403H7.329a.575.575 0 01-.554-.411l-.246-.764a.568.568 0 00-.365-.368 5.773 5.773 0 01-.723-.305.572.572 0 00-.525 0l-.712.363a.578.578 0 01-.676-.106l-.944-.944a.579.579 0 01-.107-.677l.364-.713a.563.563 0 000-.523 5.994 5.994 0 01-.306-.723.567.567 0 00-.372-.37l-.756-.237a.575.575 0 01-.403-.555V7.332a.575.575 0 01.403-.554l.764-.245a.568.568 0 00.368-.365c.085-.248.187-.489.305-.723a.572.572 0 000-.525l-.363-.712a.578.578 0 01.106-.676l.944-.944a.579.579 0 01.677-.107l.713.363c.164.086.36.086.523 0 .234-.117.476-.22.723-.305a.567.567 0 00.37-.372l.245-.764A.575.575 0 017.336 1h1.335a.576.576 0 01.547.411l.246.764c.055.174.19.31.365.368zM7.996 4.92a3.078 3.078 0 100 6.156 3.078 3.078 0 000-6.156z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/core/icons/SpinnerDots.tsx
import { useMemo } from "react";
import { Fragment, jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
var POINTS = [0, 45, 90, 135, 180, 225, 270, 315];
var SpinnerDots = ({
  width = 16
}) => {
  const dots = useMemo(
    () => POINTS.map((point, index) => /* @__PURE__ */ jsx11(
      "circle",
      {
        cy: 12,
        cx: 12,
        r: 4,
        transform: `rotate(${point}, 24, 24)`,
        fillOpacity: 1 / POINTS.length * (index + 1)
      },
      point
    )),
    []
  );
  return /* @__PURE__ */ jsxs5(Fragment, { children: [
    /* @__PURE__ */ jsx11("style", { children: "@keyframes spin{to{transform:rotate(360deg)}}" }),
    /* @__PURE__ */ jsx11(
      "svg",
      {
        viewBox: "0 0 48 48",
        width,
        fill: "currentColor",
        "data-testid": "rotating-dots-svg",
        "aria-label": "rotating-dots-loading",
        style: {
          animationDuration: "1s",
          animation: "spin 1s steps(8, end) infinite"
        },
        children: dots
      }
    )
  ] });
};

// src/ui/core/icons/TrashIcon.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var TrashIcon = (props) => /* @__PURE__ */ jsx12(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx12(
      "path",
      {
        d: "M11.825 2.335H9.39A1.396 1.396 0 008 1c-.745 0-1.36.595-1.39 1.335H4.175c-.445 0-.87.19-1.165.525-.295.34-.425.785-.365 1.225l.045.325a.5.5 0 00.495.435h9.63a.5.5 0 00.495-.435l.045-.325c.06-.44-.07-.885-.365-1.225a1.552 1.552 0 00-1.165-.525zM12.365 6.073h-8.73a.5.5 0 00-.495.565l1.025 7.027C4.27 14.425 4.93 15 5.7 15h4.6c.77 0 1.43-.575 1.535-1.335l1.025-7.027a.5.5 0 00-.495-.565z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/core/icons/WalletIcon.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var WalletIcon = (props) => /* @__PURE__ */ jsx13(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx13(
      "path",
      {
        d: "M2.835 14.13h10.756c.896 0 1.622-.726 1.622-1.623V6.245c0-.808-.655-1.466-1.466-1.466H3.791c-.351 0-.667-.256-.7-.605a.675.675 0 01.669-.742h8.736a.78.78 0 100-1.561h-8.85a2.433 2.433 0 00-2.433 2.432v8.204c0 .896.726 1.622 1.623 1.622zm9.038-5.706a1.03 1.03 0 110 2.062 1.03 1.03 0 010-2.062z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/core/icons/XmarkIcon.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var XmarkIcon = (props) => /* @__PURE__ */ jsx14(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx14(
      "path",
      {
        d: "M13.332 4.075L9.426 7.98l3.9 3.932a.964.964 0 010 1.406.964.964 0 01-1.406 0l-3.9-3.9-3.945 3.914a.964.964 0 01-1.407 0 .964.964 0 010-1.406L6.582 7.98 2.676 4.074a.964.964 0 010-1.406.964.964 0 011.406 0L8.02 6.574l3.905-3.905a.964.964 0 011.407 0 .964.964 0 010 1.406z",
        fill: "currentColor"
      }
    )
  }
);

// src/ui/theme.tsx
var Icons = {
  Loader: SpinnerDots,
  Settings: SettingsIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  Close: CloseIcon,
  Bell: BellIcon,
  BellButton: BellButtonIcon,
  BellButtonOutline: BellButtonIconOutline,
  Trash: TrashIcon,
  Xmark: XmarkIcon,
  Resend: ResendIcon,
  Wallet: WalletIcon
};
var NotificationTypeStyles = {};
var ClassTokens = {
  Text: {
    Primary: "dt-text-[--dt-text-primary]",
    Secondary: "dt-text-[--dt-text-secondary]",
    Tertiary: "dt-text-[--dt-text-tertiary]",
    Accent: "dt-text-[--dt-text-accent]",
    Success: "dt-text-[--dt-accent-success]",
    Error: "dt-text-[--dt-accent-error]",
    Inverse: "dt-text-[--dt-text-inverse]",
    Button: {
      Primary: {
        Default: "dt-text-[--dt-text-inverse]",
        Disabled: "disabled:dt-text-[--dt-text-tertiary]"
      },
      Secondary: {
        Default: "dt-text-[--dt-text-primary]",
        Disabled: "disabled:dt-text-[--dt-text-tertiary]"
      },
      Destructive: {
        Default: "dt-text-[--dt-accent-error]",
        Disabled: "disabled:dt-text-[--dt-accent-error]"
      }
    },
    Input: {
      Placeholder: "placeholder:dt-text-[--dt-text-quaternary]"
    }
  },
  Icon: {
    Primary: "dt-text-[--dt-icon-primary]",
    Secondary: "dt-text-[--dt-icon-secondary]",
    Tertiary: "dt-text-[--dt-icon-tertiary]"
  },
  Background: {
    Button: {
      Primary: {
        Default: "dt-bg-[--dt-button-primary]",
        Hover: "hover:dt-bg-[--dt-button-primary-hover]",
        Pressed: "active:dt-bg-[--dt-button-primary]",
        Disabled: "disabled:dt-bg-[--dt-button-primary-disabled]"
      },
      Secondary: {
        Default: "dt-bg-[--dt-button-secondary]",
        Hover: "hover:dt-bg-[--dt-button-secondary-hover]",
        Pressed: "active:dt-bg-[--dt-button-secondary]",
        Disabled: "disabled:dt-bg-[--dt-button-secondary-disabled]"
      },
      Destructive: {
        Default: "dt-bg-[--dt-button-secondary]",
        Hover: "hover:dt-bg-[--dt-button-secondary-hover]",
        Pressed: "active:dt-bg-[--dt-button-secondary]",
        Disabled: "disabled:dt-bg-[--dt-button-secondary-disabled]"
      }
    },
    Input: {
      Secondary: "dt-bg-[--dt-input-secondary]",
      Checked: "dt-bg-[--dt-input-checked]",
      Unchecked: "dt-bg-[--dt-input-unchecked]"
    },
    Primary: "dt-bg-[--dt-bg-primary]",
    Secondary: "dt-bg-[--dt-bg-secondary]",
    Tertiary: "dt-bg-[--dt-bg-tertiary]",
    BrandTransparent: "dt-bg-[--dt-brand-transparent]",
    SuccessTransparent: "dt-bg-[--dt-success-transparent]",
    ErrorTransparent: "dt-bg-[--dt-error-transparent]",
    AccentBrand: "dt-bg-[--dt-accent-brand]"
  },
  Stroke: {
    Input: {
      Primary: "dt-border-[--dt-input-primary]",
      Checked: "dt-border-[--dt-input-checked]",
      Error: "dt-border-[--dt-accent-error]",
      Focused: "focus-within:dt-border-[--dt-input-checked]"
    },
    Primary: "dt-border-[--dt-stroke-primary]",
    Error: "dt-border-[--dt-accent-error]"
  },
  Radius: {
    XSmall: "dt-rounded-[--dt-border-radius-xs]",
    Small: "dt-rounded-[--dt-border-radius-s]",
    Medium: "dt-rounded-[--dt-border-radius-m]",
    Large: "dt-rounded-[--dt-border-radius-l]"
  }
};

// src/ui/core/primitives/Badge.tsx
import clsx from "clsx";
import { jsx as jsx15 } from "react/jsx-runtime";
var variantClassMap = {
  default: clsx(
    ClassTokens.Text.Tertiary,
    ClassTokens.Background.BrandTransparent
  ),
  success: clsx(
    ClassTokens.Text.Success,
    ClassTokens.Background.SuccessTransparent
  ),
  error: clsx(ClassTokens.Text.Error, ClassTokens.Background.ErrorTransparent)
};
var Badge = ({
  variant = "default",
  children,
  className
}) => {
  return /* @__PURE__ */ jsx15(
    "span",
    {
      className: clsx(
        variantClassMap[variant],
        "dt-rounded-full dt-px-2.5 dt-py-0.5 dt-text-caption dt-font-semibold",
        className
      ),
      children
    }
  );
};

// src/ui/core/primitives/Button.tsx
import clsx2 from "clsx";
import { Fragment as Fragment2, jsx as jsx16, jsxs as jsxs6 } from "react/jsx-runtime";
var Button = ({
  type = "Secondary" /* Secondary */,
  size = "medium",
  stretch = false,
  ...props
}) => {
  const backgroundTokens = ClassTokens.Background.Button[type];
  const textTokens = ClassTokens.Text.Button[type];
  const styles = size === "large" ? "dt-px-6 dt-py-4 dt-text-text dt-font-semibold " + ClassTokens.Radius.Medium : "dt-px-2.5 dt-py-1.5 dt-text-subtext dt-font-semibold " + ClassTokens.Radius.XSmall;
  return /* @__PURE__ */ jsx16(
    "button",
    {
      className: clsx2(
        "dt-flex dt-items-center dt-justify-center dt-gap-1.5",
        { "dt-w-full": stretch },
        backgroundTokens.Default,
        backgroundTokens.Hover,
        backgroundTokens.Pressed,
        backgroundTokens.Disabled,
        textTokens.Default,
        textTokens.Disabled,
        styles
      ),
      onClick: props.onClick,
      disabled: props.disabled || props.loading,
      children: props.loading ? /* @__PURE__ */ jsxs6(Fragment2, { children: [
        "Loading ",
        /* @__PURE__ */ jsx16(Icons.Loader, {})
      ] }) : props.children
    }
  );
};

// src/ui/core/primitives/Checkbox.tsx
import clsx3 from "clsx";
import { jsx as jsx17, jsxs as jsxs7 } from "react/jsx-runtime";
var Checkbox = ({
  children,
  checked = false,
  disabled = false,
  onChange
}) => {
  const onClick = () => {
    if (!disabled) {
      onChange?.(!checked);
    }
  };
  return /* @__PURE__ */ jsxs7(
    "label",
    {
      className: "dt-label dt-inline-flex dt-cursor-pointer dt-items-center dt-gap-2 dt-text-subtext dt-font-semibold ",
      onClick,
      children: [
        /* @__PURE__ */ jsx17("input", { type: "hidden", checked, onChange: onClick }),
        /* @__PURE__ */ jsx17(
          "span",
          {
            className: clsx3(
              "dt-flex dt-h-5 dt-w-5 dt-items-center dt-justify-center dt-rounded-sm dt-border-2 dt-transition-colors dt-ease-in-out",
              checked ? ClassTokens.Background.Input.Checked : "dt-bg-transparent",
              //TODO input color?
              checked ? ClassTokens.Stroke.Input.Checked : ClassTokens.Stroke.Input.Primary,
              "dt-text-[--dt-input-secondary]",
              { "dt-opacity-50": disabled }
            ),
            children: checked && /* @__PURE__ */ jsx17(CheckIcon, {})
          }
        ),
        children
      ]
    }
  );
};

// src/ui/core/primitives/IconButton.tsx
import clsx4 from "clsx";
import { jsx as jsx18 } from "react/jsx-runtime";
var IconButton = ({ icon, onClick, className }) => {
  return /* @__PURE__ */ jsx18(
    "button",
    {
      className: clsx4(className, "dt-transition-opacity hover:dt-opacity-70"),
      onClick,
      children: icon
    }
  );
};

// src/ui/core/primitives/Input.tsx
import clsx5 from "clsx";
import {
  useMemo as useMemo2
} from "react";

// src/utils/random.ts
var generateIdRandom = () => {
  return Math.random().toString(36).slice(2, 9);
};

// src/ui/core/primitives/Input.tsx
import { jsx as jsx19, jsxs as jsxs8 } from "react/jsx-runtime";
var Input = ({
  id,
  label,
  rightAdornment,
  error = false,
  ...inputProps
}) => {
  const inputId = useMemo2(() => id || `dt-input-${generateIdRandom()}`, [id]);
  return /* @__PURE__ */ jsxs8("div", { className: "dt-flex dt-flex-col dt-gap-2", children: [
    label && /* @__PURE__ */ jsx19(
      "label",
      {
        htmlFor: inputId,
        className: clsx5(
          "dt-label dt-text-subtext dt-font-semibold",
          ClassTokens.Text.Tertiary
        ),
        children: label
      }
    ),
    /* @__PURE__ */ jsxs8(
      "div",
      {
        role: "textbox",
        className: clsx5(
          "dt-flex dt-h-[42px] dt-items-center dt-gap-2 dt-border dt-pl-2 dt-pr-1.5",
          ClassTokens.Radius.Small,
          error ? ClassTokens.Stroke.Input.Error : ClassTokens.Stroke.Input.Primary,
          !error && !inputProps.disabled && ClassTokens.Stroke.Input.Focused,
          ClassTokens.Background.Input.Secondary
        ),
        children: [
          /* @__PURE__ */ jsx19(
            "input",
            {
              id: inputId,
              type: "text",
              className: clsx5(
                "dt-input dt-ml-1 dt-w-full dt-bg-transparent dt-text-text dt-font-normal dt-outline-none",
                ClassTokens.Text.Primary,
                ClassTokens.Text.Input.Placeholder
              ),
              ...inputProps
            }
          ),
          rightAdornment && /* @__PURE__ */ jsx19("div", { className: "dt-flex dt-items-center", children: rightAdornment })
        ]
      }
    )
  ] });
};

// src/ui/core/primitives/Link.tsx
import clsx6 from "clsx";
import { forwardRef } from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var Link = forwardRef(function Link2({ url, children, className, ...props }, ref) {
  return /* @__PURE__ */ jsx20(
    "a",
    {
      href: url,
      ref,
      className: clsx6(ClassTokens.Text.Accent, "dt-underline", className),
      ...props,
      children
    }
  );
});

// src/ui/core/primitives/Switch.tsx
import clsx7 from "clsx";
import { jsx as jsx21, jsxs as jsxs9 } from "react/jsx-runtime";
var Switch = ({
  children,
  checked = false,
  onChange
}) => {
  return /* @__PURE__ */ jsxs9(
    "label",
    {
      className: "dt-label dt-inline-flex dt-cursor-pointer dt-items-center dt-gap-2 dt-text-subtext dt-font-semibold",
      onClick: () => onChange?.(!checked),
      children: [
        /* @__PURE__ */ jsx21(
          "input",
          {
            type: "hidden",
            checked,
            onChange: () => onChange?.(!checked)
          }
        ),
        /* @__PURE__ */ jsx21(
          "span",
          {
            className: clsx7(
              "dt-block dt-h-5 dt-w-8 dt-rounded-full dt-p-0.5 dt-transition-colors dt-ease-in-out",
              checked ? ClassTokens.Background.Input.Checked : ClassTokens.Background.Input.Unchecked
            ),
            children: /* @__PURE__ */ jsx21(
              "span",
              {
                className: clsx7(
                  "dt-block dt-h-4 dt-w-4 dt-transform dt-rounded-full dt-transition-transform dt-ease-in-out",
                  ClassTokens.Background.Input.Secondary,
                  checked ? "dt-translate-x-3" : "dt-translate-x-0"
                )
              }
            )
          }
        ),
        children
      ]
    }
  );
};

// src/ui/core/primitives/TextButton.tsx
import clsx8 from "clsx";
import { jsx as jsx22 } from "react/jsx-runtime";
var TextButton = ({
  onClick,
  disabled,
  children,
  color
}) => {
  return /* @__PURE__ */ jsx22(
    "button",
    {
      style: { color },
      className: clsx8(
        "dt-flex dt-cursor-pointer dt-items-center dt-gap-1 dt-text-subtext dt-font-semibold",
        { [ClassTokens.Text.Primary]: !color },
        "hover:dt-opacity-80 disabled:dt-opacity-50"
      ),
      onClick: disabled ? void 0 : onClick,
      disabled,
      children
    }
  );
};

// src/ui/core/Header.tsx
import { Fragment as Fragment3, jsx as jsx23, jsxs as jsxs10 } from "react/jsx-runtime";
var BackButton = ({
  onBackClick
}) => /* @__PURE__ */ jsx23(
  IconButton,
  {
    className: ClassTokens.Icon.Secondary,
    onClick: onBackClick,
    icon: /* @__PURE__ */ jsx23(Icons.ArrowLeft, {})
  }
);
var SettingsButton = ({ onSettingsClick }) => /* @__PURE__ */ jsx23(
  IconButton,
  {
    className: ClassTokens.Icon.Secondary,
    onClick: onSettingsClick,
    icon: /* @__PURE__ */ jsx23(Icons.Settings, {})
  }
);
var CloseButton = ({ onCloseClick }) => /* @__PURE__ */ jsx23(
  IconButton,
  {
    className: ClassTokens.Icon.Secondary,
    onClick: onCloseClick,
    icon: /* @__PURE__ */ jsx23(Icons.Close, {})
  }
);
function Header({
  title,
  showCloseButton = true,
  showSettingsButton = true,
  showBackButton = true,
  onSettingsClick,
  onBackClick,
  onCloseClick
}) {
  const leftButtons = /* @__PURE__ */ jsx23(Fragment3, { children: showBackButton && /* @__PURE__ */ jsx23(BackButton, { onBackClick }) });
  const rightButtons = /* @__PURE__ */ jsxs10("div", { className: "dt-flex dt-gap-3", children: [
    showSettingsButton && /* @__PURE__ */ jsx23(SettingsButton, { onSettingsClick }),
    showCloseButton && /* @__PURE__ */ jsx23(CloseButton, { onCloseClick })
  ] });
  return /* @__PURE__ */ jsxs10(
    "div",
    {
      className: clsx9(
        ClassTokens.Background.Secondary,
        "dt-flex dt-flex-row dt-items-center dt-justify-between dt-gap-4 dt-px-4 dt-py-4"
      ),
      children: [
        /* @__PURE__ */ jsxs10("div", { className: "dt-flex dt-flex-row dt-items-center dt-gap-2", children: [
          leftButtons,
          /* @__PURE__ */ jsx23(
            "span",
            {
              className: clsx9(ClassTokens.Text.Primary, "dt-text-h2 dt-font-bold"),
              children: title
            }
          )
        ] }),
        rightButtons
      ]
    }
  );
}

// src/ui/core/model/useSmartMessage.ts
import {
  useDialectSdk,
  useNotificationThreadMessages
} from "@dialectlabs/react-sdk";
import { useWallet } from "@solana/wallet-adapter-react";
import { VersionedTransaction } from "@solana/web3.js";
import { Buffer } from "buffer";
import { useCallback, useState } from "react";

// src/ui/core/model/api/smart-messages.ts
function createSmartMessageApi() {
  return {
    cancelSmartMessage: async (dialectCloudUrl, smartMessageId) => {
      try {
        const res = await fetch(
          `${dialectCloudUrl}/api/v1/smart-messages/${smartMessageId}/cancel`,
          {
            method: "POST"
          }
        );
        if (!res.ok) {
          console.warn(`Error cancelling smart message ${smartMessageId}`);
          return null;
        }
        return res.json();
      } catch (e) {
        console.warn(`Error cancelling smart message ${smartMessageId}`, e);
        return null;
      }
    },
    createSmartMessageTransaction: async (dialectCloudUrl, smartMessageId, token, command) => {
      try {
        const res = await fetch(
          `${dialectCloudUrl}/api/v1/smart-messages/${smartMessageId}/create-transaction`,
          {
            method: "POST",
            body: JSON.stringify(command),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        );
        if (!res.ok) {
          console.warn(
            `Error creating transaction for smart message ${smartMessageId}`
          );
          return null;
        }
        return res.json();
      } catch (e) {
        console.warn(`Error creating transaction for ${smartMessageId}`, e);
        return null;
      }
    },
    submitSmartMessageTransaction: async (dialectCloudUrl, smartMessageId, token, command) => {
      try {
        const res = await fetch(
          `${dialectCloudUrl}/api/v1/smart-messages/${smartMessageId}/submit-transaction`,
          {
            method: "POST",
            body: JSON.stringify(command),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        );
        if (!res.ok) {
          console.warn(
            `Error submitting transaction for smart message ${smartMessageId}`
          );
          return null;
        }
        return res.json();
      } catch (e) {
        console.warn(`Error submitting transaction for ${smartMessageId}`, e);
        return null;
      }
    }
  };
}
var smartMessageApi = createSmartMessageApi();

// src/ui/core/model/useSmartMessage.ts
var useSmartMessage = () => {
  const dialectSdk = useDialectSdk();
  const wallet = useWallet();
  const dialectCloudUrl = dialectSdk.config.dialectCloud.url;
  const { refreshMessages } = useNotificationThreadMessages();
  const [isInitiating, setIsInitiating] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const handleAction = useCallback(
    async (smartMessageId, actionHumanReadableId) => {
      try {
        if (!wallet.signTransaction) {
          return;
        }
        setIsInitiating(true);
        const token = await dialectSdk.tokenProvider.get();
        const txResponse = await smartMessageApi.createSmartMessageTransaction(
          dialectCloudUrl,
          smartMessageId,
          token.rawValue,
          { actionHumanReadableId }
        );
        if (!txResponse) {
          return;
        }
        const versionedTransaction = VersionedTransaction.deserialize(
          Buffer.from(txResponse.transaction, "base64")
        );
        const signed = await wallet.signTransaction(versionedTransaction);
        await smartMessageApi.submitSmartMessageTransaction(
          dialectCloudUrl,
          smartMessageId,
          token.rawValue,
          {
            actionHumanReadableId,
            transaction: Buffer.from(signed.serialize()).toString("base64")
          }
        );
        await refreshMessages();
      } finally {
        setIsInitiating(false);
      }
    },
    [dialectCloudUrl, dialectSdk.tokenProvider, wallet, refreshMessages]
  );
  const handleCancel = useCallback(
    async (smartMessageId) => {
      try {
        if (!wallet.signTransaction) {
          return;
        }
        setIsCancelling(true);
        await smartMessageApi.cancelSmartMessage(
          dialectCloudUrl,
          smartMessageId
        );
      } finally {
        setIsCancelling(false);
      }
    },
    [dialectCloudUrl, wallet.signTransaction]
  );
  return {
    handleSmartMessageAction: handleAction,
    handleSmartMessageCancel: handleCancel,
    isInitiatingSmartMessage: isInitiating,
    isCancellingSmartMessage: isCancelling
  };
};

// src/ui/core/wallet-state/WalletStatesWrapper.tsx
import { useDialectSdk as useDialectSdk2, useDialectWallet as useDialectWallet2 } from "@dialectlabs/react-sdk";

// src/ui/core/wallet-state/NoWalletState.tsx
import clsx10 from "clsx";
import { jsx as jsx24, jsxs as jsxs11 } from "react/jsx-runtime";
var NoWalletState = ({
  message = "Wallet not connected"
}) => {
  return /* @__PURE__ */ jsxs11("div", { className: "dt-flex dt-flex-1 dt-flex-col dt-items-center dt-justify-center dt-px-4", children: [
    /* @__PURE__ */ jsx24("div", { className: clsx10(ClassTokens.Icon.Secondary), children: /* @__PURE__ */ jsx24(Icons.Wallet, { width: 24, height: 24 }) }),
    /* @__PURE__ */ jsx24(
      "h3",
      {
        className: clsx10(
          "dt-pb-2 dt-pt-6 dt-text-h2 dt-font-semibold",
          ClassTokens.Text.Primary
        ),
        children: message
      }
    )
  ] });
};
var NoWalletState_default = NoWalletState;

// src/ui/core/wallet-state/NotAuthorizedState.tsx
import { useDialectWallet } from "@dialectlabs/react-sdk";
import clsx11 from "clsx";
import { jsx as jsx25, jsxs as jsxs12 } from "react/jsx-runtime";
var NotAuthorizedState = () => {
  const {
    hardwareWalletForcedState: {
      get: isHardwareWalletForced,
      set: setHardwareWalletForced
    },
    connectionInitiatedState: { set: setConnectionInitiated }
  } = useDialectWallet();
  return /* @__PURE__ */ jsxs12("div", { className: "dt-flex dt-flex-1 dt-flex-col dt-items-center dt-justify-center dt-px-4", children: [
    /* @__PURE__ */ jsx25(
      "h3",
      {
        className: clsx11(
          "dt-pb-2 dt-pt-6 dt-text-h2 dt-font-semibold",
          ClassTokens.Text.Primary
        ),
        children: "Verify Wallet"
      }
    ),
    /* @__PURE__ */ jsxs12(
      "span",
      {
        className: clsx11(
          "dt-text-center dt-text-text dt-font-normal",
          ClassTokens.Text.Secondary
        ),
        children: [
          "To continue, please prove you own this wallet by signing a",
          " ",
          isHardwareWalletForced ? "transaction" : "message",
          ". It is free and does not involve the network."
        ]
      }
    ),
    /* @__PURE__ */ jsxs12("div", { className: "dt-flex dt-w-full dt-flex-col dt-items-center dt-pt-6 ", children: [
      /* @__PURE__ */ jsxs12(
        "div",
        {
          className: clsx11(
            ClassTokens.Stroke.Input.Primary,
            ClassTokens.Text.Primary,
            ClassTokens.Radius.Medium,
            "dt-mb-4 dt-flex dt-h-12 dt-w-full dt-flex-row dt-items-center dt-justify-between dt-border dt-px-3 dt-py-2"
          ),
          children: [
            /* @__PURE__ */ jsx25("span", { children: "Using ledger?" }),
            /* @__PURE__ */ jsx25(
              Switch,
              {
                checked: isHardwareWalletForced,
                onChange: (next) => setHardwareWalletForced(next)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx25(
        Button,
        {
          type: "Primary" /* Primary */,
          size: "large",
          stretch: true,
          onClick: () => setConnectionInitiated(true),
          children: isHardwareWalletForced ? "Sign transaction" : "Sign message"
        }
      )
    ] })
  ] });
};
var NotAuthorizedState_default = NotAuthorizedState;

// src/ui/core/wallet-state/SigningMessageState.tsx
import clsx12 from "clsx";
import { jsx as jsx26, jsxs as jsxs13 } from "react/jsx-runtime";
var SigningMessageState = () => {
  return /* @__PURE__ */ jsxs13("div", { className: "dt-flex dt-flex-1 dt-flex-col dt-items-center dt-justify-center dt-px-4", children: [
    /* @__PURE__ */ jsx26("div", { className: clsx12(ClassTokens.Icon.Secondary), children: /* @__PURE__ */ jsx26(Icons.Loader, { width: 24, height: 24 }) }),
    /* @__PURE__ */ jsx26(
      "h3",
      {
        className: clsx12(
          "dt-pb-2 dt-pt-6 dt-text-h2 dt-font-semibold",
          ClassTokens.Text.Primary
        ),
        children: "Waiting for your wallet"
      }
    ),
    /* @__PURE__ */ jsx26(
      "p",
      {
        className: clsx12(
          "dt-text-center dt-text-text dt-font-normal",
          ClassTokens.Text.Secondary
        ),
        children: "To continue please prove you own a wallet by approving signing request. It is free and does not involve the network."
      }
    )
  ] });
};
var SigningMessageState_default = SigningMessageState;

// src/ui/core/wallet-state/SigningTransactionState.tsx
import clsx13 from "clsx";
import { jsx as jsx27, jsxs as jsxs14 } from "react/jsx-runtime";
var SigningTransactionState = () => {
  return /* @__PURE__ */ jsxs14("div", { className: "dt-flex dt-flex-1 dt-flex-col dt-items-center dt-justify-center dt-px-4", children: [
    /* @__PURE__ */ jsx27("div", { className: clsx13(ClassTokens.Icon.Secondary), children: /* @__PURE__ */ jsx27(Icons.Loader, { width: 24, height: 24 }) }),
    /* @__PURE__ */ jsx27(
      "h3",
      {
        className: clsx13(
          "dt-pb-2 dt-pt-6 dt-text-h2 dt-font-semibold",
          ClassTokens.Text.Primary
        ),
        children: "Waiting for your wallet"
      }
    ),
    /* @__PURE__ */ jsxs14(
      "p",
      {
        className: clsx13(
          "dt-text-center dt-text-text dt-font-normal",
          ClassTokens.Text.Secondary
        ),
        children: [
          "To continue please prove you own this wallet by signing a transaction. This transaction ",
          /* @__PURE__ */ jsx27("b", { children: "will not" }),
          " be submitted to the blockchain, and is free."
        ]
      }
    )
  ] });
};
var SigningTransactionState_default = SigningTransactionState;

// src/ui/core/wallet-state/WalletStatesWrapper.tsx
import { Fragment as Fragment4, jsx as jsx28, jsxs as jsxs15 } from "react/jsx-runtime";
function WalletStatesWrapper({
  header = null,
  notConnectedMessage,
  children
}) {
  const sdk = useDialectSdk2(true);
  const {
    walletConnected: { get: isWalletConnected },
    connectionInitiatedState: { get: isConnectionInitiated },
    isSigningMessageState: { get: isSigningMessage },
    isSigningFreeTransactionState: { get: isSigningFreeTransaction }
  } = useDialectWallet2();
  if (!isWalletConnected || !sdk && isConnectionInitiated) {
    return /* @__PURE__ */ jsxs15(Fragment4, { children: [
      header,
      /* @__PURE__ */ jsx28(NoWalletState_default, { message: notConnectedMessage })
    ] });
  }
  if (!isConnectionInitiated) {
    return /* @__PURE__ */ jsxs15(Fragment4, { children: [
      header,
      /* @__PURE__ */ jsx28(NotAuthorizedState_default, {})
    ] });
  }
  if (isSigningMessage) {
    return /* @__PURE__ */ jsxs15(Fragment4, { children: [
      header,
      /* @__PURE__ */ jsx28(SigningMessageState_default, {})
    ] });
  }
  if (isSigningFreeTransaction) {
    return /* @__PURE__ */ jsxs15(Fragment4, { children: [
      header,
      /* @__PURE__ */ jsx28(SigningTransactionState_default, {})
    ] });
  }
  return children;
}
var WalletStatesWrapper_default = WalletStatesWrapper;

// src/ui/notifications/NotificationsFeed/NotificationsFeed.tsx
import { useNotificationThreadMessages as useNotificationThreadMessages2 } from "@dialectlabs/react-sdk";
import { useEffect } from "react";

// src/ui/notifications/NotificationsFeed/NoNotifications.tsx
import clsx14 from "clsx";

// src/ui/notifications/internal/Router.tsx
import { createContext, useContext, useMemo as useMemo3, useState as useState2 } from "react";
import { jsx as jsx29 } from "react/jsx-runtime";
var RouterContext = createContext(null);
var Router = ({
  initialRoute,
  children
}) => {
  const [route, setRoute] = useState2(initialRoute ?? "notifications" /* Notifications */);
  const context = useMemo3(() => ({ route, setRoute }), [route]);
  return /* @__PURE__ */ jsx29(RouterContext.Provider, { value: context, children: children(route) });
};
var useRouter = () => {
  const context = useContext(RouterContext);
  if (!context) {
    throw new Error("useRouter must be used within a Router");
  }
  return context;
};

// src/ui/notifications/NotificationsFeed/NoNotifications.tsx
import { jsx as jsx30, jsxs as jsxs16 } from "react/jsx-runtime";
var NoNotifications = () => {
  const router = useRouter();
  return /* @__PURE__ */ jsxs16("div", { className: "dt-flex dt-h-full dt-flex-1 dt-flex-col dt-items-center dt-justify-center dt-px-4", children: [
    /* @__PURE__ */ jsx30("div", { className: clsx14(ClassTokens.Icon.Secondary), children: /* @__PURE__ */ jsx30(Icons.Bell, { width: 24, height: 24 }) }),
    /* @__PURE__ */ jsx30(
      "h3",
      {
        className: clsx14(
          "dt-pb-2 dt-pt-6 dt-text-center dt-text-h2 dt-font-semibold",
          ClassTokens.Text.Primary
        ),
        children: "You don\u2019t have any notifications yet"
      }
    ),
    /* @__PURE__ */ jsx30(
      "p",
      {
        className: clsx14(
          "dt-mb-6 dt-text-center dt-text-text dt-font-normal",
          ClassTokens.Text.Secondary
        ),
        children: "Enable your wallet to receive notifications."
      }
    ),
    /* @__PURE__ */ jsxs16(
      Button,
      {
        type: "Primary" /* Primary */,
        size: "large",
        stretch: true,
        onClick: () => router.setRoute("settings" /* Settings */),
        children: [
          /* @__PURE__ */ jsx30(Icons.Settings, {}),
          " Set up notifications"
        ]
      }
    )
  ] });
};

// src/ui/notifications/NotificationsFeed/NotificationsList.tsx
import { useMemo as useMemo5 } from "react";

// src/ui/notifications/NotificationsFeed/NotificationMessage/index.tsx
import { ActionType } from "@dialectlabs/sdk";
import clsx16 from "clsx";
import { useMemo as useMemo4 } from "react";
import { LinkIt } from "react-linkify-it";

// src/ui/notifications/NotificationsFeed/context.ts
import { createContext as createContext2, useContext as useContext2 } from "react";
var NotificationsItemsContext = createContext2({ list: [], map: {} });
var useNotification = (id) => {
  const items = useContext2(NotificationsItemsContext);
  return items.map[id];
};

// src/ui/notifications/NotificationsFeed/NotificationMessage/ButtonAction.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var ButtonAction = ({ onClick, disabled, label, loading }) => {
  return /* @__PURE__ */ jsx31(
    Button,
    {
      size: "medium",
      type: disabled ? "Secondary" /* Secondary */ : "Primary" /* Primary */,
      disabled,
      onClick,
      loading,
      children: label
    }
  );
};

// src/ui/notifications/NotificationsFeed/NotificationMessage/LinkAction.tsx
import clsx15 from "clsx";

// src/ui/notifications/NotificationsFeed/NotificationMessage/utils.ts
var getMessageURLTarget = (url) => {
  const urlObj = new URL(url);
  if (urlObj.hostname === window.location.hostname) {
    return "_self";
  }
  return "_blank";
};
var timeFormatter = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true
});
var getColor = (color, theme) => {
  if (!color) {
    return;
  }
  if (typeof color === "string") {
    return color;
  }
  return color[theme || "light"];
};

// src/ui/notifications/NotificationsFeed/NotificationMessage/LinkAction.tsx
import { jsx as jsx32, jsxs as jsxs17 } from "react/jsx-runtime";
var LinkAction = ({
  url,
  label = "Open Link",
  styles
}) => {
  return /* @__PURE__ */ jsx32(
    "a",
    {
      href: url,
      target: getMessageURLTarget(url),
      className: clsx15(
        "dt-flex dt-flex-row dt-items-center dt-gap-0.5 dt-text-subtext dt-font-semibold"
      ),
      rel: "noreferrer",
      children: /* @__PURE__ */ jsxs17(TextButton, { color: getColor(styles.linkColor), children: [
        label,
        /* @__PURE__ */ jsx32(Icons.ArrowRight, { width: 12, height: 12 })
      ] })
    }
  );
};

// src/ui/notifications/NotificationsFeed/NotificationMessage/index.tsx
import { Fragment as Fragment5, jsx as jsx33, jsxs as jsxs18 } from "react/jsx-runtime";
var NotificationMessage = (message) => {
  const styles = getStyles(message.metadata?.notificationTypeHumanReadableId);
  return /* @__PURE__ */ jsxs18(
    "div",
    {
      className: clsx16(
        ClassTokens.Stroke.Primary,
        "dt-relative dt-flex dt-flex-row dt-items-center dt-gap-4 dt-overflow-hidden dt-border-b dt-px-4 dt-py-3"
      ),
      children: [
        /* @__PURE__ */ jsx33(
          NotificationMessage.Icon,
          {
            styles,
            isActionable: Boolean(message.metadata?.smartMessage),
            overrideIconUrl: message.metadata?.smartMessage?.content.layout.icon
          }
        ),
        /* @__PURE__ */ jsxs18("div", { className: "dt-min-w-0", children: [
          /* @__PURE__ */ jsx33(
            NotificationMessage.ActionStatus,
            {
              action: message.metadata?.smartMessage
            }
          ),
          /* @__PURE__ */ jsx33(NotificationMessage.Title, { children: message.metadata?.title }),
          /* @__PURE__ */ jsx33(NotificationMessage.Text, { children: message.text }),
          /* @__PURE__ */ jsx33(
            NotificationMessage.Actions,
            {
              styles,
              action: message.metadata?.smartMessage
            }
          ),
          /* @__PURE__ */ jsx33(NotificationMessage.Timestamp, { timestamp: message.timestamp })
        ] })
      ]
    }
  );
};
NotificationMessage.Timestamp = function NotificationTimestamp({
  timestamp
}) {
  return /* @__PURE__ */ jsx33("div", { className: clsx16("dt-mt-3 dt-text-caption", ClassTokens.Text.Tertiary), children: timeFormatter.format(timestamp.getTime()) });
};
var MAX_URL_LENGTH = 32;
var URL_REGEX = /(https?:\/\/|www\.)([-\w.]+\/[\p{L}\p{Emoji}\p{Emoji_Component}!#$%&'"()*+,./\\:;=_?@[\]~-]*[^\s'",.;:\b)\]}?]|(([\w-]+\.)+[\w-]+[\w/-]))/u;
NotificationMessage.Text = function NotificationMessageText({
  children
}) {
  const messageText = useMemo4(
    () => /* @__PURE__ */ jsx33(
      LinkIt,
      {
        regex: URL_REGEX,
        component: (url, key) => /* @__PURE__ */ jsx33(
          "a",
          {
            href: url,
            target: getMessageURLTarget(url),
            className: "dt-font-medium dt-underline",
            children: url.length > MAX_URL_LENGTH ? `${url.slice(0, MAX_URL_LENGTH)}...` : url
          },
          key
        ),
        children
      }
    ),
    [children]
  );
  return /* @__PURE__ */ jsx33(
    "div",
    {
      className: clsx16(
        ClassTokens.Text.Primary,
        "dt-whitespace-pre-wrap dt-break-words dt-text-subtext"
      ),
      children: messageText
    }
  );
};
NotificationMessage.Title = function NotificationTitle({
  children
}) {
  return children ? /* @__PURE__ */ jsx33(
    "div",
    {
      className: clsx16(
        ClassTokens.Text.Primary,
        "dt-mb-1 dt-whitespace-pre-wrap dt-break-words dt-text-text dt-font-semibold"
      ),
      children
    }
  ) : null;
};
NotificationMessage.Icon = function NotificationIcon({
  overrideIconUrl,
  styles,
  isActionable
}) {
  return /* @__PURE__ */ jsxs18(Fragment5, { children: [
    /* @__PURE__ */ jsx33(
      "div",
      {
        className: "dt-pointer-events-none dt-absolute -dt-bottom-[36%] -dt-top-[36%] dt-left-0 dt-w-[240px] -dt-translate-x-1/2 dt-transform",
        style: {
          background: isActionable && styles.actionGradientStartColor ? `radial-gradient(50% 50% at 50% 50%, ${getColor(styles.actionGradientStartColor)} 0%, transparent 100%)` : "transparent"
        }
      }
    ),
    /* @__PURE__ */ jsx33("div", { className: "dt-relative", children: overrideIconUrl ? /* @__PURE__ */ jsx33(
      "div",
      {
        className: clsx16(
          "dt-h-8 dt-w-8 dt-overflow-hidden dt-border",
          ClassTokens.Radius.XSmall,
          ClassTokens.Stroke.Primary
        ),
        children: /* @__PURE__ */ jsx33(
          "img",
          {
            src: overrideIconUrl,
            alt: "",
            className: "dt-h-full dt-w-full dt-object-cover"
          }
        )
      }
    ) : /* @__PURE__ */ jsx33(
      "div",
      {
        className: clsx16("dt-h-8 dt-w-8 dt-rounded-full dt-p-1.5"),
        style: {
          background: getColor(styles.iconBackgroundBackdropColor)
        },
        children: /* @__PURE__ */ jsx33(
          "div",
          {
            className: clsx16(
              "dt-flex dt-h-full dt-w-full dt-items-center dt-justify-center dt-rounded-full"
            ),
            style: {
              background: getColor(styles.iconBackgroundColor),
              color: getColor(styles.iconColor)
            },
            children: styles.Icon
          }
        )
      }
    ) })
  ] });
};
NotificationMessage.Actions = function NotificationActions({
  action,
  styles
}) {
  const {
    handleSmartMessageAction,
    isInitiatingSmartMessage,
    handleSmartMessageCancel,
    isCancellingSmartMessage
  } = useSmartMessage();
  const layoutElements = useMemo4(
    () => action?.content.layout.elements.flat() ?? [],
    [action]
  );
  if (!action) {
    return null;
  }
  return /* @__PURE__ */ jsxs18("div", { className: "dt-mt-3", children: [
    /* @__PURE__ */ jsx33("div", { className: "dt-flex dt-flex-row dt-items-center dt-gap-2", children: layoutElements.map((layoutElement, index) => {
      if (layoutElement.type === "label") {
        return /* @__PURE__ */ jsx33(
          ButtonAction,
          {
            label: layoutElement.text,
            disabled: true
          },
          `label-${index}`
        );
      }
      if (layoutElement.action.type === "SIGN_TRANSACTION") {
        const buttonAction = layoutElement.action;
        return /* @__PURE__ */ jsx33(
          ButtonAction,
          {
            label: layoutElement.text,
            disabled: isCancellingSmartMessage || isInitiatingSmartMessage,
            loading: isInitiatingSmartMessage,
            onClick: () => handleSmartMessageAction(
              action.id,
              buttonAction.humanReadableId
            )
          },
          `button-sign-${index}`
        );
      }
      if (layoutElement.action.type === "CANCEL") {
        return /* @__PURE__ */ jsx33(
          ButtonAction,
          {
            label: layoutElement.text,
            disabled: isCancellingSmartMessage || isInitiatingSmartMessage,
            loading: isCancellingSmartMessage,
            onClick: () => handleSmartMessageCancel(action.id)
          },
          `button-cancel-${index}`
        );
      }
      return /* @__PURE__ */ jsx33(
        LinkAction,
        {
          url: layoutElement.action.link,
          styles,
          label: layoutElement.text
        },
        `button-link-${index}`
      );
    }) }),
    action.content.layout.description && /* @__PURE__ */ jsx33(
      "div",
      {
        className: clsx16(
          "dt-mt-3 dt-text-caption",
          ClassTokens.Text.Secondary
        ),
        children: action.content.layout.description
      }
    )
  ] });
};
var getBadgeVariant = (state) => {
  switch (state) {
    case "SUCCEEDED" /* Succeeded */:
      return "success";
    case "FAILED" /* Failed */:
      return "error";
    default:
      return "default";
  }
};
var actionStateTextMap = {
  ["CREATED" /* Created */]: "Ready",
  ["READY_FOR_EXECUTION" /* ReadyForExecution */]: "Executing",
  ["EXECUTING" /* Executing */]: "Executing",
  ["SUCCEEDED" /* Succeeded */]: "Succeeded",
  ["FAILED" /* Failed */]: "Failed",
  ["CANCELED" /* Canceled */]: "Canceled"
};
NotificationMessage.ActionStatus = function NotificationActionStatus({
  action
}) {
  if (!action || action.content.layout.elements.flat().every(
    (el) => el.type === "button" && el.action.type === ActionType.OpenLink
  )) {
    return null;
  }
  return /* @__PURE__ */ jsx33("div", { className: "dt-mb-2", children: /* @__PURE__ */ jsx33(Badge, { variant: getBadgeVariant(action.content.state), children: actionStateTextMap[action.content.state] }) });
};
var DefaultMessageStyles = {
  Icon: /* @__PURE__ */ jsx33(Icons.Bell, { width: 12, height: 12 }),
  iconColor: "var(--dt-icon-primary)",
  iconBackgroundColor: "var(--dt-bg-brand)",
  iconBackgroundBackdropColor: "var(--dt-brand-transparent)",
  linkColor: "var(--dt-accent-brand)",
  actionGradientStartColor: "transparent"
};
var getStyles = (notificationType) => {
  if (notificationType) {
    return NotificationTypeStyles[notificationType] ?? DefaultMessageStyles;
  }
  return DefaultMessageStyles;
};
NotificationMessage.Container = function NotificationMessageContainer({
  id
}) {
  const notification = useNotification(id);
  if (!notification) {
    return null;
  }
  return /* @__PURE__ */ jsx33(NotificationMessage, { ...notification });
};

// src/ui/notifications/NotificationsFeed/NotificationsList.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var NotificationsList = ({ children }) => {
  return /* @__PURE__ */ jsx34("div", { className: "dt-flex dt-flex-col", children });
};
NotificationsList.Container = function NotificationListContainer({
  messages
}) {
  const context = useMemo5(() => {
    return {
      list: messages.map((it) => it.id),
      map: Object.fromEntries(messages.map((it) => [it.id, it]))
    };
  }, [messages]);
  return /* @__PURE__ */ jsx34(NotificationsItemsContext.Provider, { value: context, children: /* @__PURE__ */ jsx34(NotificationsList, { children: messages.map((it) => /* @__PURE__ */ jsx34(NotificationMessage.Container, { id: it.id }, it.id)) }) });
};

// src/ui/notifications/NotificationsFeed/NotificationsLoading.tsx
import clsx17 from "clsx";
import { jsx as jsx35, jsxs as jsxs19 } from "react/jsx-runtime";
var NotificationsLoading = () => {
  return /* @__PURE__ */ jsxs19("div", { className: "dt-flex dt-h-full dt-flex-1 dt-flex-col dt-items-center dt-justify-center dt-px-4", children: [
    /* @__PURE__ */ jsx35("div", { className: clsx17(ClassTokens.Icon.Secondary), children: /* @__PURE__ */ jsx35(Icons.Loader, { width: 24, height: 24 }) }),
    /* @__PURE__ */ jsx35(
      "h3",
      {
        className: clsx17(
          "dt-pb-2 dt-pt-6 dt-text-h2 dt-font-semibold",
          ClassTokens.Text.Primary
        ),
        children: "Loading your notifications"
      }
    )
  ] });
};

// src/ui/notifications/NotificationsFeed/NotificationsFeed.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var NotificationsFeed = ({
  children,
  isEmpty,
  isLoading
}) => {
  if (isLoading) {
    return /* @__PURE__ */ jsx36(NotificationsLoading, {});
  }
  if (isEmpty) {
    return /* @__PURE__ */ jsx36(NoNotifications, {});
  }
  return children;
};
NotificationsFeed.Container = function NotificationsFeeContainer() {
  const { messages, isMessagesLoading, markAsRead } = useNotificationThreadMessages2();
  useEffect(() => {
    if (messages.length > 0) {
      markAsRead();
    }
  }, [messages.length, markAsRead]);
  return /* @__PURE__ */ jsx36(
    NotificationsFeed,
    {
      isEmpty: messages.length === 0,
      isLoading: isMessagesLoading,
      children: /* @__PURE__ */ jsx36(NotificationsList.Container, { messages })
    }
  );
};

// src/ui/notifications/internal/ExternalPropsProvider.tsx
import { createContext as createContext3, useContext as useContext3 } from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var ExternalPropsContext = createContext3(null);
var ExternalPropsProvider = ({
  children,
  props
}) => {
  return /* @__PURE__ */ jsx37(ExternalPropsContext.Provider, { value: props, children });
};
var useExternalProps = () => {
  const context = useContext3(ExternalPropsContext);
  if (!context) {
    throw new Error(
      "useExternalProps must be used within a ExternalPropsProvider"
    );
  }
  return context;
};

// src/ui/notifications/NotificationsFeed/NotificationsFeedHeader.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
var NotificationsFeedHeader = () => {
  const { setOpen } = useExternalProps();
  const { setRoute } = useRouter();
  return /* @__PURE__ */ jsx38(
    Header,
    {
      title: "Notifications",
      showBackButton: false,
      showSettingsButton: true,
      showCloseButton: !!setOpen,
      onSettingsClick: () => setRoute("settings" /* Settings */),
      onCloseClick: () => setOpen?.(false)
    }
  );
};

// src/ui/notifications/NotificationsFeed/NotificationsFeedScreen.tsx
import { jsx as jsx39, jsxs as jsxs20 } from "react/jsx-runtime";
var NotificationsFeedScreen = () => {
  return /* @__PURE__ */ jsxs20("div", { className: "dt-flex dt-h-full dt-flex-col", children: [
    /* @__PURE__ */ jsx39(NotificationsFeedHeader, {}),
    /* @__PURE__ */ jsx39("section", { className: "dt-h-full dt-overflow-y-auto", children: /* @__PURE__ */ jsx39(NotificationsFeed.Container, {}) })
  ] });
};

// src/ui/notifications/Settings/Settings.tsx
import {
  AddressType as AddressType9,
  useDialectContext as useDialectContext5,
  useNotificationChannelDappSubscription as useNotificationChannelDappSubscription4,
  useNotificationSubscriptions as useNotificationSubscriptions2
} from "@dialectlabs/react-sdk";
import clsx27 from "clsx";

// src/ui/notifications/Settings/AppInfo.tsx
import { REACT_SDK_VERSION } from "@dialectlabs/react-sdk";
import clsx18 from "clsx";
import { jsx as jsx40, jsxs as jsxs21 } from "react/jsx-runtime";
var AppInfo = () => {
  return /* @__PURE__ */ jsxs21("div", { className: "dt-flex dt-flex-col dt-items-center dt-justify-center dt-gap-2.5", children: [
    /* @__PURE__ */ jsxs21(
      "div",
      {
        className: clsx18(
          "dt-inline-flex dt-items-center dt-justify-center dt-px-2 dt-py-1 dt-text-caption",
          ClassTokens.Radius.Large,
          ClassTokens.Background.Secondary,
          ClassTokens.Text.Tertiary
        ),
        children: [
          "Powered By",
          " ",
          /* @__PURE__ */ jsx40(
            "a",
            {
              href: "https://dialect.to",
              target: "_blank",
              rel: "noreferrer",
              className: "hover:dt-text-inherit",
              children: /* @__PURE__ */ jsx40(DialectLogo, { className: "-dt-mt-[1px] dt-ml-[3px]" })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx40("div", { className: "dt-flex dt-items-center dt-justify-center", children: /* @__PURE__ */ jsxs21("span", { className: clsx18("dt-text-caption", ClassTokens.Text.Tertiary), children: [
      version,
      " / ",
      REACT_SDK_VERSION
    ] }) })
  ] });
};

// src/ui/notifications/Settings/Channels/index.tsx
import { memo } from "react";

// src/ui/notifications/Settings/Channels/EmailChannel/index.tsx
import {
  AddressType as AddressType4,
  useDialectContext,
  useNotificationChannel as useNotificationChannel3
} from "@dialectlabs/react-sdk";

// src/ui/notifications/Settings/Channels/EmailChannel/EmailInput.tsx
import {
  AddressType,
  useNotificationChannel,
  useNotificationChannelDappSubscription
} from "@dialectlabs/react-sdk";
import clsx19 from "clsx";
import { useCallback as useCallback2, useEffect as useEffect2, useMemo as useMemo6, useState as useState3 } from "react";

// src/ui/notifications/Settings/Channels/ChannelNotificationsToggle.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var ChannelNotificationsToggle = ({ enabled, onChange }) => /* @__PURE__ */ jsx41(
  Switch,
  {
    checked: enabled,
    onChange,
    children: `Notifications ${enabled ? "On" : "Off"}`
  }
);

// src/ui/notifications/Settings/Channels/EmailChannel/EmailInput.tsx
import { jsx as jsx42, jsxs as jsxs22 } from "react/jsx-runtime";
var EMAIL_REGEX = new RegExp("^\\S+@\\S+\\.\\S+$");
var EmailInput = ({ dappAddress }) => {
  const {
    globalAddress: emailAddress,
    create: createAddress,
    delete: deleteAddress,
    update: updateAddress,
    isCreatingAddress,
    isUpdatingAddress,
    isDeletingAddress,
    isSendingCode,
    isVerifyingCode,
    errorFetching: errorFetchingAddresses
  } = useNotificationChannel({ addressType: AddressType.Email });
  const {
    enabled: subscriptionEnabled,
    toggleSubscription,
    isToggling
  } = useNotificationChannelDappSubscription({
    addressType: AddressType.Email,
    dappAddress
  });
  const [email, setEmail] = useState3(emailAddress?.value || "");
  const isEmailValid = useMemo6(() => EMAIL_REGEX.test(email), [email]);
  const isEmailEmpty = useMemo6(() => !email, [email]);
  const [validationError, setValidationError] = useState3(false);
  useEffect2(() => {
    if (isEmailEmpty || isEmailValid) {
      setValidationError(false);
    }
  }, [isEmailEmpty, isEmailValid]);
  const [error, setError] = useState3(null);
  const [isUserDeleting, setIsUserDeleting] = useState3(false);
  const isEmailSaved = Boolean(emailAddress);
  const isVerified = Boolean(emailAddress?.verified);
  const isLoading = isCreatingAddress || isUpdatingAddress || isDeletingAddress || isSendingCode || isVerifyingCode || isToggling;
  const currentError = error || errorFetchingAddresses;
  const updateEmail = useCallback2(async () => {
    {
      try {
        await updateAddress({ value: email });
        setError(null);
      } catch (e) {
        setError(e);
      }
    }
  }, [email, updateAddress]);
  const saveEmail = useCallback2(async () => {
    {
      try {
        const address = await createAddress({ value: email });
        await toggleSubscription({ enabled: true, address });
        setError(null);
      } catch (e) {
        setError(e);
      }
    }
  }, [createAddress, email, toggleSubscription]);
  const deleteEmail = useCallback2(async () => {
    try {
      await deleteAddress();
      setEmail("");
      setIsUserDeleting(false);
      setError(null);
    } catch (e) {
      setError(e);
    }
  }, [deleteAddress]);
  const toggleEmail = async (nextValue) => {
    try {
      await toggleSubscription({
        enabled: nextValue
      });
      setError(null);
    } catch (e) {
      setError(e);
    }
  };
  const isUserEditing = emailAddress?.value !== email && isEmailSaved;
  const getButton = useCallback2(() => {
    if (isEmailEmpty)
      return null;
    if (isLoading) {
      return /* @__PURE__ */ jsx42("div", { className: clsx19(ClassTokens.Icon.Tertiary, "dt-p-2"), children: /* @__PURE__ */ jsx42(Icons.Loader, {}) });
    }
    if (isUserDeleting) {
      return /* @__PURE__ */ jsx42(Button, { onClick: deleteEmail, type: "Destructive" /* Destructive */, children: "Delete" });
    }
    if (isUserEditing) {
      return /* @__PURE__ */ jsx42(
        Button,
        {
          onClick: () => {
            if (!isEmailValid) {
              setValidationError(true);
            } else {
              updateEmail();
            }
          },
          disabled: !isEmailValid,
          children: "Submit"
        }
      );
    }
    if (isVerified) {
      return /* @__PURE__ */ jsx42(
        IconButton,
        {
          className: "dt-p-2 " + ClassTokens.Icon.Tertiary,
          onClick: () => setIsUserDeleting(true),
          icon: /* @__PURE__ */ jsx42(Icons.Trash, {})
        }
      );
    }
    return /* @__PURE__ */ jsx42(
      Button,
      {
        onClick: () => {
          if (!isEmailValid) {
            setValidationError(true);
          } else {
            saveEmail();
          }
        },
        disabled: !isEmailValid,
        children: "Submit"
      }
    );
  }, [
    deleteEmail,
    isEmailEmpty,
    isEmailValid,
    isLoading,
    isUserDeleting,
    isUserEditing,
    isVerified,
    saveEmail,
    updateEmail
  ]);
  return /* @__PURE__ */ jsxs22("div", { children: [
    /* @__PURE__ */ jsx42(
      Input,
      {
        label: "Email",
        placeholder: "Enter your Email",
        id: "settings-email",
        value: email,
        error: validationError,
        disabled: isLoading || isUserDeleting,
        onChange: (e) => {
          setEmail(e.target.value);
        },
        onBlur: () => setValidationError(!isEmailEmpty && !isEmailValid),
        rightAdornment: getButton()
      }
    ),
    isEmailSaved && isVerified && !isUserEditing && !isUserDeleting && /* @__PURE__ */ jsx42("div", { className: "dt-mt-2", children: /* @__PURE__ */ jsx42(
      ChannelNotificationsToggle,
      {
        enabled: subscriptionEnabled,
        onChange: toggleEmail
      }
    ) }),
    validationError && /* @__PURE__ */ jsx42("p", { className: clsx19(ClassTokens.Text.Error, "dt-mt-2 dt-text-caption"), children: "Please enter a valid Email" }),
    currentError && /* @__PURE__ */ jsx42("p", { className: clsx19(ClassTokens.Text.Error, "dt-mt-2 dt-text-caption"), children: currentError.message }),
    isUserDeleting && /* @__PURE__ */ jsxs22("div", { className: "dt-mt-2 dt-flex dt-flex-col dt-gap-2", children: [
      /* @__PURE__ */ jsx42("p", { className: clsx19(ClassTokens.Text.Tertiary, "dt-text-caption"), children: "Deleting your email here will delete it across all dapps you\u2019ve signed up." }),
      /* @__PURE__ */ jsxs22(
        TextButton,
        {
          disabled: isLoading,
          onClick: () => setIsUserDeleting(false),
          children: [
            /* @__PURE__ */ jsx42(Icons.Xmark, { height: 12, width: 12 }),
            "Cancel"
          ]
        }
      )
    ] }),
    isUserEditing && /* @__PURE__ */ jsxs22("div", { className: "dt-mt-2 dt-flex dt-flex-col dt-gap-2", children: [
      /* @__PURE__ */ jsx42("p", { className: clsx19(ClassTokens.Text.Tertiary, "dt-text-caption"), children: "Updating your email here will update it across all dapps you\u2019ve signed up." }),
      /* @__PURE__ */ jsxs22(
        TextButton,
        {
          disabled: isLoading,
          onClick: () => {
            setEmail(emailAddress?.value || "");
          },
          children: [
            /* @__PURE__ */ jsx42(Icons.Xmark, { height: 12, width: 12 }),
            "Cancel"
          ]
        }
      )
    ] })
  ] });
};

// src/ui/notifications/Settings/Channels/EmailChannel/EmailVerificationCodeInput.tsx
import { AddressType as AddressType3 } from "@dialectlabs/react-sdk";
import clsx20 from "clsx";
import { useMemo as useMemo7 } from "react";

// src/ui/notifications/Settings/Channels/model/useVerificationCode.ts
import { useNotificationChannel as useNotificationChannel2 } from "@dialectlabs/react-sdk";
import { useState as useState4 } from "react";
var useVerificationCode = (addressType) => {
  const [verificationCode, setVerificationCode] = useState4("");
  const [currentError, setCurrentError] = useState4(null);
  const {
    verify,
    resend,
    isSendingCode,
    isVerifyingCode,
    delete: deleteAddr
  } = useNotificationChannel2({
    addressType
  });
  const sendCode = async () => {
    try {
      await verify({ code: verificationCode });
      setCurrentError(null);
    } catch (e) {
      setCurrentError(e);
    } finally {
      setVerificationCode("");
    }
  };
  const resendCode = async () => {
    try {
      await resend();
      setCurrentError(null);
    } catch (e) {
      setCurrentError(e);
    }
  };
  const deleteAddress = async () => {
    try {
      await deleteAddr();
      setCurrentError(null);
    } catch (e) {
      setCurrentError(e);
    }
  };
  return {
    verificationCode,
    setVerificationCode,
    sendCode,
    isSendingCode: isVerifyingCode,
    resendCode,
    isResendingCode: isSendingCode,
    deleteAddress,
    currentError
  };
};

// src/ui/notifications/Settings/Channels/EmailChannel/EmailVerificationCodeInput.tsx
import { jsx as jsx43, jsxs as jsxs23 } from "react/jsx-runtime";
var VERIFICATION_CODE_REGEX = new RegExp("^[0-9]{6}$");
var EmailVerificationCodeInput = ({ email }) => {
  const {
    verificationCode,
    setVerificationCode,
    sendCode,
    resendCode,
    isSendingCode,
    isResendingCode,
    deleteAddress,
    currentError
  } = useVerificationCode(AddressType3.Email);
  const isCodeValid = useMemo7(
    () => VERIFICATION_CODE_REGEX.test(verificationCode),
    [verificationCode]
  );
  const isLoading = isSendingCode || isResendingCode;
  return /* @__PURE__ */ jsxs23("div", { children: [
    /* @__PURE__ */ jsx43(
      Input,
      {
        id: "settings-verification-code-email",
        placeholder: "Enter verification code",
        label: "Email",
        type: "text",
        value: verificationCode,
        onChange: (e) => setVerificationCode(e.target.value),
        rightAdornment: isLoading ? /* @__PURE__ */ jsx43("div", { className: clsx20(ClassTokens.Icon.Tertiary, "dt-p-2"), children: /* @__PURE__ */ jsx43(Icons.Loader, {}) }) : /* @__PURE__ */ jsx43(
          Button,
          {
            onClick: isCodeValid ? sendCode : void 0,
            disabled: !isCodeValid,
            children: "Submit"
          }
        )
      }
    ),
    currentError && /* @__PURE__ */ jsx43("p", { className: clsx20(ClassTokens.Text.Error, "dt-mt-2 dt-text-caption"), children: currentError.message }),
    /* @__PURE__ */ jsxs23("div", { className: "dt-mt-2 dt-flex dt-flex-col dt-gap-2", children: [
      /* @__PURE__ */ jsxs23("p", { className: clsx20(ClassTokens.Text.Tertiary, "dt-text-caption"), children: [
        "Check your ",
        /* @__PURE__ */ jsxs23("span", { className: ClassTokens.Text.Primary, children: [
          email,
          " "
        ] }),
        "inbox for a verification code."
      ] }),
      /* @__PURE__ */ jsxs23("div", { className: "dt-flex dt-flex-row dt-items-center dt-gap-8", children: [
        /* @__PURE__ */ jsxs23(TextButton, { onClick: deleteAddress, disabled: isLoading, children: [
          /* @__PURE__ */ jsx43(Icons.Xmark, { height: 12, width: 12 }),
          "Cancel"
        ] }),
        /* @__PURE__ */ jsxs23(TextButton, { onClick: resendCode, disabled: isLoading, children: [
          /* @__PURE__ */ jsx43(Icons.Resend, { height: 12, width: 12 }),
          "Resend Code"
        ] })
      ] })
    ] })
  ] });
};

// src/ui/notifications/Settings/Channels/EmailChannel/index.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var EmailChannel = () => {
  const { dappAddress } = useDialectContext();
  const { globalAddress: emailAddress } = useNotificationChannel3({
    addressType: AddressType4.Email
  });
  const isEmailSaved = Boolean(emailAddress);
  const isVerified = Boolean(emailAddress?.verified);
  const verificationNeeded = isEmailSaved && !isVerified;
  return /* @__PURE__ */ jsx44("div", { children: verificationNeeded ? /* @__PURE__ */ jsx44(EmailVerificationCodeInput, { email: emailAddress?.value ?? "" }) : /* @__PURE__ */ jsx44(EmailInput, { dappAddress }) });
};

// src/ui/notifications/Settings/Channels/TelegramChannel/index.tsx
import {
  AddressType as AddressType7,
  useDialectContext as useDialectContext2,
  useNotificationChannel as useNotificationChannel5,
  useNotificationDapp
} from "@dialectlabs/react-sdk";

// src/ui/notifications/Settings/Channels/TelegramChannel/TelegramHandleInput.tsx
import {
  AddressType as AddressType5,
  useNotificationChannel as useNotificationChannel4,
  useNotificationChannelDappSubscription as useNotificationChannelDappSubscription2
} from "@dialectlabs/react-sdk";
import clsx21 from "clsx";
import { useEffect as useEffect3, useState as useState5 } from "react";
import { jsx as jsx45, jsxs as jsxs24 } from "react/jsx-runtime";
var TelegramHandleInput = ({
  dappAddress
}) => {
  const {
    globalAddress: telegramAddress,
    create: createAddress,
    delete: deleteAddress,
    update: updateAddress,
    isCreatingAddress,
    isUpdatingAddress,
    isDeletingAddress,
    isSendingCode,
    isVerifyingCode,
    errorFetching: errorFetchingAddresses
  } = useNotificationChannel4({ addressType: AddressType5.Telegram });
  const {
    enabled: subscriptionEnabled,
    toggleSubscription,
    isToggling
  } = useNotificationChannelDappSubscription2({
    addressType: AddressType5.Telegram,
    dappAddress
  });
  const [telegramUsername, setTelegramUsername] = useState5(
    telegramAddress?.value || ""
  );
  const [error, setError] = useState5(null);
  const [isUserDeleting, setIsUserDeleting] = useState5(false);
  const isTelegramSaved = Boolean(telegramAddress);
  const isVerified = Boolean(telegramAddress?.verified);
  const isLoading = isCreatingAddress || isUpdatingAddress || isDeletingAddress || isSendingCode || isVerifyingCode || isToggling;
  const currentError = error || errorFetchingAddresses;
  useEffect3(() => {
    setTelegramUsername(telegramAddress?.value || "");
  }, [isTelegramSaved, telegramAddress?.value]);
  const updateTelegram = async () => {
    try {
      await updateAddress({
        value: telegramUsername
      });
      setError(null);
      setIsUserDeleting(false);
    } catch (e) {
      setError(e);
    }
  };
  const saveTelegram = async () => {
    try {
      const value = telegramUsername.replace("@", "");
      const address = await createAddress({ value });
      await toggleSubscription({ enabled: true, address });
      setError(null);
    } catch (e) {
      setError(e);
    }
  };
  const deleteTelegram = async () => {
    try {
      await deleteAddress();
      setTelegramUsername("");
      setIsUserDeleting(false);
      setError(null);
    } catch (e) {
      setError(e);
    }
  };
  const toggleTelegram = async (next) => {
    try {
      await toggleSubscription({
        enabled: next
      });
      setError(null);
    } catch (e) {
      setError(e);
    }
  };
  const isUserEditing = telegramAddress?.value !== telegramUsername && isTelegramSaved;
  const getButton = () => {
    if (!telegramUsername)
      return null;
    if (isLoading) {
      return /* @__PURE__ */ jsx45("div", { className: clsx21(ClassTokens.Icon.Tertiary, "dt-p-2"), children: /* @__PURE__ */ jsx45(Icons.Loader, {}) });
    }
    if (isUserDeleting) {
      return /* @__PURE__ */ jsx45(Button, { onClick: deleteTelegram, type: "Destructive" /* Destructive */, children: "Delete" });
    }
    if (isUserEditing) {
      return /* @__PURE__ */ jsx45(Button, { onClick: updateTelegram, children: "Submit" });
    }
    if (isVerified) {
      return /* @__PURE__ */ jsx45(
        IconButton,
        {
          className: "dt-p-2 " + ClassTokens.Icon.Tertiary,
          onClick: () => setIsUserDeleting(true),
          icon: /* @__PURE__ */ jsx45(Icons.Trash, {})
        }
      );
    }
    return /* @__PURE__ */ jsx45(Button, { onClick: saveTelegram, children: "Submit" });
  };
  return /* @__PURE__ */ jsxs24("div", { children: [
    /* @__PURE__ */ jsx45(
      Input,
      {
        label: "Telegram",
        placeholder: "Enter your Telegram @Username",
        id: "settings-telegram",
        value: telegramUsername,
        disabled: isLoading || isUserDeleting,
        onChange: (e) => {
          setTelegramUsername(e.target.value);
        },
        rightAdornment: getButton()
      }
    ),
    isTelegramSaved && isVerified && !isUserEditing && !isUserDeleting && /* @__PURE__ */ jsx45("div", { className: "dt-mt-2", children: /* @__PURE__ */ jsx45(
      ChannelNotificationsToggle,
      {
        enabled: subscriptionEnabled,
        onChange: toggleTelegram
      }
    ) }),
    currentError && /* @__PURE__ */ jsx45("p", { className: clsx21(ClassTokens.Text.Error, "dt-mt-2 dt-text-caption"), children: currentError.message }),
    isUserDeleting && /* @__PURE__ */ jsxs24("div", { className: "dt-mt-2 dt-flex dt-flex-col dt-gap-2", children: [
      /* @__PURE__ */ jsx45("p", { className: clsx21(ClassTokens.Text.Tertiary, "dt-text-caption"), children: "Deleting your Telegram handle here will delete it across all dapps you\u2019ve signed up." }),
      /* @__PURE__ */ jsxs24(TextButton, { onClick: () => setIsUserDeleting(false), children: [
        /* @__PURE__ */ jsx45(Icons.Xmark, { height: 12, width: 12 }),
        "Cancel"
      ] })
    ] }),
    isUserEditing && /* @__PURE__ */ jsxs24("div", { className: "dt-mt-2 dt-flex dt-flex-col dt-gap-2", children: [
      /* @__PURE__ */ jsx45("p", { className: clsx21(ClassTokens.Text.Tertiary, "dt-text-caption"), children: "Updating your Telegram handle here will update it across all dapps you\u2019ve signed up." }),
      /* @__PURE__ */ jsxs24(
        TextButton,
        {
          onClick: () => {
            setTelegramUsername(telegramAddress?.value || "");
          },
          children: [
            /* @__PURE__ */ jsx45(Icons.Xmark, { height: 12, width: 12 }),
            "Cancel"
          ]
        }
      )
    ] })
  ] });
};

// src/ui/notifications/Settings/Channels/TelegramChannel/TelegramVerificationCodeInput.tsx
import { AddressType as AddressType6, useDialectSdk as useDialectSdk3 } from "@dialectlabs/react-sdk";
import clsx22 from "clsx";
import { useMemo as useMemo8 } from "react";
import { jsx as jsx46, jsxs as jsxs25 } from "react/jsx-runtime";
var VERIFICATION_CODE_REGEX2 = new RegExp("^[0-9]{6}$");
var TelegramVerificationCodeInput = ({
  dappTelegramName
}) => {
  const {
    config: { environment }
  } = useDialectSdk3();
  const {
    verificationCode,
    setVerificationCode,
    sendCode,
    isSendingCode,
    deleteAddress,
    currentError
  } = useVerificationCode(AddressType6.Telegram);
  const buildBotUrl = (botUsername) => `https://t.me/${botUsername}?start=${botUsername}`;
  const defaultBotUrl = environment === "production" ? buildBotUrl("DialectLabsBot") : buildBotUrl("DialectLabsDevBot");
  const botURL = useMemo8(() => {
    if (!dappTelegramName) {
      return defaultBotUrl;
    }
    return buildBotUrl(dappTelegramName);
  }, [dappTelegramName, defaultBotUrl]);
  const isCodeValid = useMemo8(
    () => VERIFICATION_CODE_REGEX2.test(verificationCode),
    [verificationCode]
  );
  return /* @__PURE__ */ jsxs25("div", { children: [
    /* @__PURE__ */ jsx46(
      Input,
      {
        id: "settings-verification-code-telegram",
        placeholder: "Enter verification code",
        label: "Telegram",
        type: "text",
        value: verificationCode,
        onChange: (e) => setVerificationCode(e.target.value),
        rightAdornment: isSendingCode ? /* @__PURE__ */ jsx46("div", { className: clsx22(ClassTokens.Icon.Tertiary, "dt-p-2"), children: /* @__PURE__ */ jsx46(Icons.Loader, {}) }) : /* @__PURE__ */ jsx46(
          Button,
          {
            onClick: isCodeValid ? sendCode : void 0,
            disabled: !isCodeValid,
            children: "Submit"
          }
        )
      }
    ),
    currentError && /* @__PURE__ */ jsx46("p", { className: clsx22(ClassTokens.Text.Error, "dt-mt-2 dt-text-caption"), children: currentError.message }),
    /* @__PURE__ */ jsxs25("div", { className: "dt-mt-2 dt-flex dt-flex-col dt-gap-2", children: [
      /* @__PURE__ */ jsxs25(
        "a",
        {
          className: clsx22(ClassTokens.Text.Tertiary, "dt-text-caption"),
          href: botURL,
          target: "_blank",
          rel: "noreferrer",
          children: [
            "Message",
            /* @__PURE__ */ jsx46("span", { className: ClassTokens.Text.Accent, children: " this bot " }),
            "on Telegram to get your verification code."
          ]
        }
      ),
      /* @__PURE__ */ jsxs25(TextButton, { onClick: deleteAddress, disabled: isSendingCode, children: [
        /* @__PURE__ */ jsx46(Icons.Xmark, { height: 12, width: 12 }),
        "Cancel"
      ] })
    ] })
  ] });
};

// src/ui/notifications/Settings/Channels/TelegramChannel/index.tsx
import { jsx as jsx47 } from "react/jsx-runtime";
var TelegramChannel = () => {
  const { dappAddress } = useDialectContext2();
  const { globalAddress: telegramAddress } = useNotificationChannel5({
    addressType: AddressType7.Telegram
  });
  const isTelegramSaved = Boolean(telegramAddress);
  const isVerified = Boolean(telegramAddress?.verified);
  const { dapp } = useNotificationDapp();
  const verificationNeeded = isTelegramSaved && !isVerified;
  return /* @__PURE__ */ jsx47("div", { children: verificationNeeded ? /* @__PURE__ */ jsx47(
    TelegramVerificationCodeInput,
    {
      dappTelegramName: dapp?.telegramUsername ?? ""
    }
  ) : /* @__PURE__ */ jsx47(TelegramHandleInput, { dappAddress }) });
};

// src/ui/notifications/Settings/Channels/WalletChannel.tsx
import {
  AddressType as AddressType8,
  ThreadMemberScope,
  useDialectContext as useDialectContext3,
  useDialectSdk as useDialectSdk4,
  useNotificationChannel as useNotificationChannel6,
  useNotificationChannelDappSubscription as useNotificationChannelDappSubscription3,
  useNotificationThread,
  useUnreadNotifications
} from "@dialectlabs/react-sdk";
import clsx23 from "clsx";
import { useCallback as useCallback3 } from "react";

// src/utils/displayAddress.ts
function displayAddress(address, chars = 4) {
  const addr = address.toString();
  return `${addr.substring(0, chars)}...${addr.substring(addr.length - chars)}`;
}

// src/ui/notifications/Settings/Channels/WalletChannel.tsx
import { jsx as jsx48, jsxs as jsxs26 } from "react/jsx-runtime";
var ADDRESS_TYPE = AddressType8.Wallet;
var WalletChannel = () => {
  const { dappAddress } = useDialectContext3();
  const {
    wallet: { address: walletAddress }
  } = useDialectSdk4();
  const {
    thread,
    create: createThread,
    isCreatingThread,
    delete: deleteThread,
    isDeletingThread
  } = useNotificationThread();
  const { refresh: refreshUnreadNotifications } = useUnreadNotifications({
    revalidateOnMount: false
  });
  const {
    globalAddress: walletSubscriptionAddress,
    create: createAddress,
    delete: deleteAddress,
    isCreatingAddress,
    isDeletingAddress
  } = useNotificationChannel6({ addressType: ADDRESS_TYPE });
  const {
    enabled: subscriptionEnabled,
    toggleSubscription,
    isToggling
  } = useNotificationChannelDappSubscription3({
    addressType: ADDRESS_TYPE,
    dappAddress
  });
  const deleteWalletThread = useCallback3(async () => {
    await deleteThread();
    await deleteAddress();
  }, [deleteAddress, deleteThread]);
  const createWalletThread = useCallback3(async () => {
    if (!dappAddress)
      return;
    return createThread({
      me: { scopes: [ThreadMemberScope.ADMIN] },
      otherMembers: [
        { address: dappAddress, scopes: [ThreadMemberScope.WRITE] }
      ],
      encrypted: false
    });
  }, [createThread, dappAddress]);
  const createWalletAddress = useCallback3(
    () => createAddress({ value: walletAddress }),
    [createAddress, walletAddress]
  );
  const isLoading = isDeletingThread || isCreatingThread || isDeletingAddress || isCreatingAddress || isToggling;
  const setUpWallet = useCallback3(async () => {
    if (isLoading)
      return;
    const noSubscription = !walletSubscriptionAddress && !thread;
    let notificationsThread;
    if (!thread) {
      notificationsThread = await createWalletThread();
      refreshUnreadNotifications();
    }
    let walletAddress2;
    if (!walletSubscriptionAddress) {
      walletAddress2 = await createWalletAddress();
    }
    if (noSubscription && notificationsThread) {
      await toggleSubscription({ enabled: true, address: walletAddress2 });
    }
  }, [
    createWalletAddress,
    createWalletThread,
    isLoading,
    refreshUnreadNotifications,
    thread,
    toggleSubscription,
    walletSubscriptionAddress
  ]);
  const isWalletSetUp = thread && walletSubscriptionAddress;
  const RightAdornment = useCallback3(() => {
    if (isLoading)
      return /* @__PURE__ */ jsx48("div", { className: clsx23(ClassTokens.Icon.Tertiary, "dt-p-2"), children: /* @__PURE__ */ jsx48(Icons.Loader, {}) });
    if (isWalletSetUp)
      return /* @__PURE__ */ jsx48(
        IconButton,
        {
          className: "dt-p-2 " + ClassTokens.Icon.Tertiary,
          onClick: deleteWalletThread,
          icon: /* @__PURE__ */ jsx48(Icons.Trash, {})
        }
      );
    return /* @__PURE__ */ jsx48(Button, { onClick: setUpWallet, children: "Enable" });
  }, [deleteWalletThread, isLoading, isWalletSetUp, setUpWallet]);
  return /* @__PURE__ */ jsxs26("div", { className: "dt-flex dt-flex-col dt-gap-2", children: [
    /* @__PURE__ */ jsx48(
      Input,
      {
        label: "In App",
        disabled: true,
        value: displayAddress(walletAddress),
        rightAdornment: /* @__PURE__ */ jsx48(RightAdornment, {})
      }
    ),
    isWalletSetUp && /* @__PURE__ */ jsx48(
      ChannelNotificationsToggle,
      {
        enabled: subscriptionEnabled,
        onChange: (newValue) => {
          if (isToggling)
            return;
          return toggleSubscription({ enabled: newValue });
        }
      }
    )
  ] });
};

// src/ui/notifications/Settings/Channels/index.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var Channel = ({ type }) => {
  const ChannelRow = () => {
    if (type === "email")
      return /* @__PURE__ */ jsx49(EmailChannel, {});
    if (type === "telegram")
      return /* @__PURE__ */ jsx49(TelegramChannel, {});
    return /* @__PURE__ */ jsx49(WalletChannel, {});
  };
  return /* @__PURE__ */ jsx49("div", { className: "dt-py-2", children: /* @__PURE__ */ jsx49(ChannelRow, {}) });
};
var Channels = memo(function Channels2({ channels }) {
  return /* @__PURE__ */ jsx49("div", { children: channels.map((it) => /* @__PURE__ */ jsx49(Channel, { type: it }, it)) });
});

// src/ui/notifications/Settings/NotificationTypes.tsx
import {
  useDialectContext as useDialectContext4,
  useNotificationSubscriptions
} from "@dialectlabs/react-sdk";
import clsx24 from "clsx";
import { memo as memo2 } from "react";
import { Fragment as Fragment6, jsx as jsx50, jsxs as jsxs27 } from "react/jsx-runtime";
var NotificationType = ({ title, description, enabled, onChange }) => {
  return /* @__PURE__ */ jsxs27(
    "div",
    {
      className: clsx24(
        ClassTokens.Background.Tertiary,
        ClassTokens.Radius.Medium,
        "dt-flex dt-flex-row dt-items-center dt-justify-between dt-gap-3 dt-px-4 dt-py-3"
      ),
      children: [
        /* @__PURE__ */ jsxs27("div", { className: "dt-flex dt-flex-col dt-gap-1", children: [
          /* @__PURE__ */ jsx50(
            "span",
            {
              className: clsx24(
                ClassTokens.Text.Primary,
                "dt-text-text dt-font-semibold"
              ),
              children: title
            }
          ),
          description && /* @__PURE__ */ jsx50(
            "span",
            {
              className: clsx24(
                ClassTokens.Text.Tertiary,
                "dt-text-subtext dt-font-normal"
              ),
              children: description
            }
          )
        ] }),
        /* @__PURE__ */ jsx50(Checkbox, { checked: enabled, onChange })
      ]
    }
  );
};
var NotificationTypes = memo2(function NotificationTypes2() {
  const { dappAddress } = useDialectContext4();
  const {
    subscriptions: notificationSubscriptions,
    update: updateNotificationSubscription,
    isUpdating,
    errorUpdating: errorUpdatingNotificationSubscription,
    errorFetching: errorFetchingNotificationsConfigs
  } = useNotificationSubscriptions({ dappAddress });
  const error = errorFetchingNotificationsConfigs || errorUpdatingNotificationSubscription;
  return /* @__PURE__ */ jsxs27("div", { className: "dt-flex dt-flex-col dt-gap-2", children: [
    error && /* @__PURE__ */ jsx50("p", { className: clsx24(ClassTokens.Text.Error), children: error.message }),
    Boolean(notificationSubscriptions.length) && /* @__PURE__ */ jsxs27(Fragment6, { children: [
      /* @__PURE__ */ jsx50(
        "p",
        {
          className: clsx24(
            ClassTokens.Text.Tertiary,
            "dt-text-subtext dt-font-semibold"
          ),
          children: "Notification Type"
        }
      ),
      notificationSubscriptions.map(
        ({ notificationType, subscription }) => /* @__PURE__ */ jsx50(
          NotificationType,
          {
            title: notificationType.name,
            description: notificationType.trigger,
            enabled: subscription.config.enabled,
            onChange: (value) => {
              if (isUpdating)
                return;
              updateNotificationSubscription({
                notificationTypeId: notificationType.id,
                config: {
                  ...subscription.config,
                  enabled: value
                }
              });
            }
          },
          notificationType.id
        )
      )
    ] })
  ] });
});

// src/ui/notifications/Settings/SettingsLoading.tsx
import clsx25 from "clsx";
import { jsx as jsx51 } from "react/jsx-runtime";
var SettingsLoading = () => {
  return /* @__PURE__ */ jsx51("div", { className: "dt-flex dt-h-full dt-flex-1 dt-flex-col dt-items-center dt-justify-center dt-px-4", children: /* @__PURE__ */ jsx51("div", { className: clsx25(ClassTokens.Icon.Secondary), children: /* @__PURE__ */ jsx51(Icons.Loader, { width: 24, height: 24 }) }) });
};

// src/ui/notifications/Settings/TosAndPrivacy.tsx
import clsx26 from "clsx";
import { jsx as jsx52, jsxs as jsxs28 } from "react/jsx-runtime";
var TosAndPrivacy = () => /* @__PURE__ */ jsx52("div", { children: /* @__PURE__ */ jsxs28(
  "p",
  {
    className: clsx26(
      ClassTokens.Text.Tertiary,
      "dt-text-center dt-text-caption"
    ),
    children: [
      "By enabling notifications you agree to Dialect's",
      " ",
      /* @__PURE__ */ jsx52(Link, { target: "_blank", rel: "noreferrer", url: "https://www.dialect.to/tos", children: "Terms of Service" }),
      " ",
      "and",
      " ",
      /* @__PURE__ */ jsx52(
        Link,
        {
          target: "_blank",
          rel: "noreferrer",
          url: "https://www.dialect.to/privacy",
          children: "Privacy Policy"
        }
      )
    ]
  }
) });

// src/ui/notifications/Settings/Settings.tsx
import { jsx as jsx53, jsxs as jsxs29 } from "react/jsx-runtime";
var Settings = ({
  renderAdditionalSettingsUi
}) => {
  const { dappAddress } = useDialectContext5();
  const subscription = useNotificationChannelDappSubscription4({
    addressType: AddressType9.Wallet,
    dappAddress
  });
  const { isFetching: isFetchingNotificationsSubscriptions } = useNotificationSubscriptions2({ dappAddress });
  const isLoading = subscription.isFetchingSubscriptions || isFetchingNotificationsSubscriptions;
  const { channels } = useExternalProps();
  return isLoading ? /* @__PURE__ */ jsx53(SettingsLoading, {}) : /* @__PURE__ */ jsxs29("div", { className: "dt-flex dt-h-full dt-flex-col", children: [
    /* @__PURE__ */ jsx53("div", { className: "dt-px-4 dt-py-3", children: /* @__PURE__ */ jsx53(Channels, { channels }) }),
    /* @__PURE__ */ jsx53("div", { className: "dt-px-4", children: /* @__PURE__ */ jsx53(NotificationTypes, {}) }),
    renderAdditionalSettingsUi?.({}),
    /* @__PURE__ */ jsx53("div", { className: "dt-flex-1" }),
    /* @__PURE__ */ jsxs29(
      "div",
      {
        className: clsx27(
          "dt-flex dt-flex-col dt-gap-2 dt-px-4 dt-py-4",
          ClassTokens.Stroke.Primary
        ),
        children: [
          /* @__PURE__ */ jsx53(TosAndPrivacy, {}),
          /* @__PURE__ */ jsx53(AppInfo, {})
        ]
      }
    )
  ] });
};

// src/ui/notifications/Settings/SettingsHeader.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var SettingsHeader = () => {
  const { setOpen } = useExternalProps();
  const { setRoute } = useRouter();
  return /* @__PURE__ */ jsx54(
    Header,
    {
      title: "Notifications Settings",
      showBackButton: true,
      showSettingsButton: false,
      showCloseButton: !!setOpen,
      onBackClick: () => setRoute("notifications" /* Notifications */),
      onCloseClick: () => setOpen?.(false)
    }
  );
};

// src/ui/notifications/Settings/SettingsScreen.tsx
import { jsx as jsx55, jsxs as jsxs30 } from "react/jsx-runtime";
var SettingsScreen = ({
  renderAdditionalSettingsUi
}) => {
  return /* @__PURE__ */ jsxs30("div", { className: "dt-flex dt-h-full dt-flex-col", children: [
    /* @__PURE__ */ jsx55(SettingsHeader, {}),
    /* @__PURE__ */ jsx55("section", { className: "dt-h-full dt-overflow-y-scroll", children: /* @__PURE__ */ jsx55(Settings, { renderAdditionalSettingsUi }) })
  ] });
};

// src/ui/notifications/Notifications.tsx
import { Fragment as Fragment7, jsx as jsx56, jsxs as jsxs31 } from "react/jsx-runtime";
var DEFAULT_CHANNELS = ["wallet", "telegram", "email"];
var NotificationsBase = ({
  channels = DEFAULT_CHANNELS,
  open,
  setOpen,
  theme,
  renderAdditionalSettingsUi
} = {
  channels: DEFAULT_CHANNELS
}) => {
  const normalizedExtProps = useMemo9(
    () => ({
      open,
      setOpen,
      theme,
      channels: Array.from(new Set(channels))
    }),
    [open, setOpen, theme, channels]
  );
  return /* @__PURE__ */ jsx56(ExternalPropsProvider, { props: normalizedExtProps, children: /* @__PURE__ */ jsx56(
    "div",
    {
      className: clsx28(
        "dt-flex dt-h-full dt-w-full dt-flex-col",
        ClassTokens.Background.Primary
      ),
      children: /* @__PURE__ */ jsx56(
        WalletStatesWrapper_default,
        {
          header: /* @__PURE__ */ jsx56(
            Header,
            {
              title: "Notifications",
              showBackButton: false,
              showSettingsButton: false,
              showCloseButton: !!setOpen,
              onCloseClick: () => setOpen?.(false)
            }
          ),
          children: /* @__PURE__ */ jsx56(Router, { initialRoute: "notifications" /* Notifications */, children: (route) => /* @__PURE__ */ jsxs31(Fragment7, { children: [
            route === "settings" /* Settings */ && /* @__PURE__ */ jsx56(
              SettingsScreen,
              {
                renderAdditionalSettingsUi
              }
            ),
            route === "notifications" /* Notifications */ && /* @__PURE__ */ jsx56(NotificationsFeedScreen, {})
          ] }) })
        }
      )
    }
  ) });
};
var Notifications = memo3(function Notifications2(props) {
  return /* @__PURE__ */ jsx56("div", { className: "dialect", "data-theme": props.theme, children: /* @__PURE__ */ jsx56(NotificationsBase, { ...props }) });
});

// src/ui/notifications/NotificationsButton.tsx
import { useUnreadNotifications as useUnreadNotifications2 } from "@dialectlabs/react-sdk";
import clsx29 from "clsx";
import {
  forwardRef as forwardRef2,
  memo as memo4,
  useCallback as useCallback4,
  useEffect as useEffect5,
  useMemo as useMemo10,
  useRef as useRef2,
  useState as useState6
} from "react";

// src/ui/notifications/internal/useClickAway.ts
import { useEffect as useEffect4, useRef } from "react";
var defaultEvents = ["mousedown", "touchstart"];
var useClickAway = (refs, onClickAway, events = defaultEvents) => {
  const savedCallback = useRef(onClickAway);
  useEffect4(() => {
    savedCallback.current = onClickAway;
  }, [onClickAway]);
  useEffect4(() => {
    const handler = (event) => {
      let shouldIgnore = false;
      refs.forEach((ref) => {
        const el = ref.current;
        shouldIgnore = shouldIgnore || Boolean(el?.contains(event.target));
      });
      !shouldIgnore && savedCallback.current(event);
    };
    for (const eventName of events) {
      document.addEventListener(eventName, handler);
    }
    return () => {
      for (const eventName of events) {
        document.removeEventListener(eventName, handler);
      }
    };
  }, [events, refs]);
};

// src/ui/notifications/NotificationsButton.tsx
import { jsx as jsx57, jsxs as jsxs32 } from "react/jsx-runtime";
var Modal = forwardRef2(function Modal2(props, modalRef) {
  if (!props.open) {
    return null;
  }
  return /* @__PURE__ */ jsx57("div", { ref: modalRef, className: "dt-modal", children: /* @__PURE__ */ jsx57(NotificationsBase, { ...props }) });
});
var DefaultNotificationIconButton = forwardRef2(function DefaultNotificationIconButton2({ open, onClick, unread }, ref) {
  return /* @__PURE__ */ jsx57(
    "button",
    {
      ref,
      onClick,
      className: clsx29(
        "dt-group dt-relative dt-flex dt-h-10 dt-w-10 dt-items-center dt-justify-center dt-transition-colors dt-duration-200 dt-ease-in-out",
        ClassTokens.Background.Button.Secondary.Default,
        ClassTokens.Background.Button.Secondary.Hover,
        ClassTokens.Radius.Small
      ),
      children: /* @__PURE__ */ jsxs32("div", { className: "dt-relative", children: [
        unread && /* @__PURE__ */ jsx57(
          "span",
          {
            className: clsx29(
              "dt-absolute dt-right-0 dt-top-[1px] dt-h-2 dt-w-2 dt-rounded-full dt-border-2 dt-border-[--dt-button-secondary] dt-transition-colors dt-duration-200 dt-ease-in-out group-hover:dt-border-[--dt-button-secondary-hover]",
              ClassTokens.Background.AccentBrand
            )
          }
        ),
        open ? /* @__PURE__ */ jsx57(Icons.BellButton, {}) : /* @__PURE__ */ jsx57(Icons.BellButtonOutline, {})
      ] })
    }
  );
});
var NotificationsButtonPresentation = ({
  theme,
  children
}) => {
  return /* @__PURE__ */ jsx57("div", { className: "dialect", "data-theme": theme, children: /* @__PURE__ */ jsx57("div", { className: clsx29("dt-relative", ClassTokens.Text.Primary), children }) });
};
var DEFAULT_INTERVAL = 1e4;
NotificationsButtonPresentation.Container = function NotificationsButtonContainer({
  channels,
  renderModalComponent,
  children,
  theme,
  renderAdditionalSettingsUi
}) {
  const buttonRef = useRef2(null);
  const modalRef = useRef2(null);
  const [open, setOpen] = useState6(false);
  const [refreshInterval, setRefreshInterval] = useState6(DEFAULT_INTERVAL);
  const { unreadCount, hasNotificationsThread } = useUnreadNotifications2({
    refreshInterval,
    revalidateOnFocus: Boolean(refreshInterval)
  });
  useEffect5(() => {
    if (open || !hasNotificationsThread) {
      setRefreshInterval(0);
    } else {
      setRefreshInterval(DEFAULT_INTERVAL);
    }
  }, [hasNotificationsThread, open]);
  useClickAway([buttonRef, modalRef], () => setOpen(false));
  const externalProps = useMemo10(
    () => ({ open, setOpen, channels, theme, renderAdditionalSettingsUi }),
    [open, channels, theme, renderAdditionalSettingsUi]
  );
  const toggle = useCallback4(() => setOpen((prev) => !prev), []);
  return /* @__PURE__ */ jsxs32(NotificationsButtonPresentation, { theme, children: [
    children ? children({ open, setOpen, unreadCount, ref: buttonRef }) : /* @__PURE__ */ jsx57(
      DefaultNotificationIconButton,
      {
        ref: buttonRef,
        open,
        onClick: toggle,
        unread: unreadCount > 0
      }
    ),
    renderModalComponent ? renderModalComponent({
      open,
      setOpen,
      ref: modalRef,
      children: /* @__PURE__ */ jsx57(NotificationsBase, { ...externalProps })
      // `children` MUST BE USED
    }) : /* @__PURE__ */ jsx57(Modal, { ref: modalRef, ...externalProps })
  ] });
};
var NotificationsButton = memo4(
  NotificationsButtonPresentation.Container
);
export {
  Icons,
  NotificationTypeStyles,
  Notifications,
  NotificationsButton,
  version as REACT_UI_VERSION
};
//# sourceMappingURL=index.js.map